import React, { useState, useEffect, useRef } from 'react';
import { API_BASE_URL } from '../config';
import '@fortawesome/fontawesome-free/css/all.min.css';
import AIAssistant from './AIAssistant';
import VerifiedNumbers from '../sections/dashboard/VerifiedNumbers';

// Comprehensive list of business types
const businessTypes = [
  { value: "chief_executives", label: "Chief Executives and Managing Directors" },
  { value: "general_managers", label: "General Managers" },
  { value: "legislators", label: "Legislators" },
  { value: "aquaculture_farmers", label: "Aquaculture Farmers" },
  { value: "crop_farmers", label: "Crop Farmers" },
  { value: "livestock_farmers", label: "Livestock Farmers" },
  { value: "mixed_crop_livestock_farmers", label: "Mixed Crop and Livestock Farmers" },
  { value: "advertising_pr_sales_manager", label: "Advertising, Public Relations and Sales Manager" },
  { value: "corporate_services_managers", label: "Corporate Services Managers" },
  { value: "finance_managers", label: "Finance Managers" },
  { value: "human_resource_managers", label: "Human Resource Managers" },
  { value: "policy_planning_managers", label: "Policy and Planning Managers" },
  { value: "research_development_managers", label: "Research and Development Managers" },
  { value: "construction_managers", label: "Construction Managers" },
  { value: "engineering_managers", label: "Engineering Managers" },
  { value: "importers_exporters_wholesalers", label: "Importers, Exporters and Wholesalers" },
  { value: "manufacturers", label: "Manufacturers" },
  { value: "production_managers", label: "Production Managers" },
  { value: "supply_distribution_procurement_managers", label: "Supply, Distribution and Procurement Managers" },
  { value: "child_care_centre_managers", label: "Child Care Centre Managers" },
  { value: "health_welfare_services_managers", label: "Health and Welfare Services Managers" },
  { value: "school_principals", label: "School Principals" },
  { value: "other_education_managers", label: "Other Education Managers" },
  { value: "ict_managers", label: "ICT Managers" },
  { value: "commissioned_officers_management", label: "Commissioned Officers (Management)" },
  { value: "senior_non_commissioned_defence", label: "Senior Non-Commissioned Defence Force Officers" },
  { value: "other_specialist_managers", label: "Other Specialist Managers" },
  { value: "cafe_restaurant_managers", label: "Cafe and Restaurant Managers" },
  { value: "caravan_park_camping_ground_managers", label: "Caravan Park and Camping Ground Managers" },
  { value: "hotel_motel_managers", label: "Hotel and Motel Managers" },
  { value: "licensed_club_managers", label: "Licensed Club Managers" },
  { value: "other_accommodation_hospitality_managers", label: "Other Accommodation and Hospitality Managers" },
  { value: "retail_managers", label: "Retail Managers" },
  { value: "amusement_fitness_sports_centre_managers", label: "Amusement, Fitness and Sports Centre Managers" },
  { value: "call_contact_centre_customer_service_managers", label: "Call, Contact Centre and Customer Service Managers" },
  { value: "conference_event_organisers", label: "Conference and Event Organisers" },
  { value: "transport_services_managers", label: "Transport Services Managers" },
  { value: "other_hospitality_retail_service_managers", label: "Other Hospitality, Retail and Service Managers" },
  { value: "actors_dancers_entertainers", label: "Actors, Dancers and Other Entertainers" },
  { value: "music_professionals", label: "Music Professionals" },
  { value: "photographers", label: "Photographers" },
  { value: "visual_arts_crafts_professionals", label: "Visual Arts and Crafts Professionals" },
  { value: "artistic_directors_media_producers", label: "Artistic Directors, Media Producers and Presenters" },
  { value: "authors_book_script_editors", label: "Authors, and Book and Script Editors" },
  { value: "film_television_radio_stage_directors", label: "Film, Television, Radio and Stage Directors" },
  { value: "journalists_writers", label: "Journalists and Other Writers" },
  { value: "accountants", label: "Accountants" },
  { value: "auditors_company_secretaries", label: "Auditors, Company Secretaries and Corporate Treasurers" },
  { value: "financial_brokers", label: "Financial Brokers" },
  { value: "financial_dealers", label: "Financial Dealers" },
  { value: "financial_investment_advisers", label: "Financial Investment Advisers and Managers" },
  { value: "human_resource_professionals", label: "Human Resource Professionals" },
  { value: "ict_trainers", label: "ICT Trainers" },
  { value: "training_development_professionals", label: "Training and Development Professionals" },
  { value: "actuaries_mathematicians_statisticians", label: "Actuaries, Mathematicians and Statisticians" },
  { value: "archivists_curators_records_managers", label: "Archivists, Curators and Records Managers" },
  { value: "economists", label: "Economists" },
  { value: "intelligence_policy_analysts", label: "Intelligence and Policy Analysts" },
  { value: "land_economists_valuers", label: "Land Economists and Valuers" },
  { value: "librarians", label: "Librarians" },
  { value: "management_organisation_analysts", label: "Management and Organisation Analysts" },
  { value: "other_information_organisation_professionals", label: "Other Information and Organisation Professionals" },
  { value: "advertising_marketing_professionals", label: "Advertising and Marketing Professionals" },
  { value: "ict_sales_professionals", label: "ICT Sales Professionals" },
  { value: "public_relations_professionals", label: "Public Relations Professionals" },
  { value: "technical_sales_representatives", label: "Technical Sales Representatives" },
  { value: "air_transport_professionals", label: "Air Transport Professionals" },
  { value: "marine_transport_professionals", label: "Marine Transport Professionals" },
  { value: "architects_landscape_architects", label: "Architects and Landscape Architects" },
  { value: "surveyors_spatial_scientists", label: "Surveyors and Spatial Scientists" },
  { value: "fashion_industrial_jewellery_designers", label: "Fashion, Industrial and Jewellery Designers" },
  { value: "graphic_web_designers_illustrators", label: "Graphic and Web Designers, and Illustrators" },
  { value: "interior_designers", label: "Interior Designers" },
  { value: "urban_regional_planners", label: "Urban and Regional Planners" },
  { value: "chemical_materials_engineers", label: "Chemical and Materials Engineers" },
  { value: "civil_engineering_professionals", label: "Civil Engineering Professionals" },
  { value: "electrical_engineers", label: "Electrical Engineers" },
  { value: "electronics_engineers", label: "Electronics Engineers" },
  { value: "industrial_mechanical_production_engineers", label: "Industrial, Mechanical and Production Engineers" },
  { value: "mining_engineers", label: "Mining Engineers" },
  { value: "other_engineering_professionals", label: "Other Engineering Professionals" },
  { value: "agricultural_forestry_scientists", label: "Agricultural and Forestry Scientists" },
  { value: "chemists_food_wine_scientists", label: "Chemists, and Food and Wine Scientists" },
  { value: "environmental_scientists", label: "Environmental Scientists" },
  { value: "geologists_geophysicists_hydrogeologists", label: "Geologists, Geophysicists and Hydrogeologists" },
  { value: "life_scientists", label: "Life Scientists" },
  { value: "medical_laboratory_scientists", label: "Medical Laboratory Scientists" },
  { value: "veterinarians", label: "Veterinarians" },
  { value: "other_natural_physical_science_professionals", label: "Other Natural and Physical Science Professionals" },
  { value: "early_childhood_teachers", label: "Early Childhood (Pre-primary School) Teachers" },
  { value: "primary_school_teachers", label: "Primary School Teachers" },
  { value: "middle_school_teachers", label: "Middle School Teachers" },
  { value: "secondary_school_teachers", label: "Secondary School Teachers" },
  { value: "special_education_teachers", label: "Special Education Teachers" },
  { value: "university_lecturers_tutors", label: "University Lecturers and Tutors" },
  { value: "vocational_education_teachers", label: "Vocational Education Teachers" },
  { value: "education_advisers_reviewers", label: "Education Advisers and Reviewers" },
  { value: "private_tutors_teachers", label: "Private Tutors and Teachers" },
  { value: "teachers_english_other_languages", label: "Teachers of English to Speakers of Other Languages" },
  { value: "nutrition_professionals", label: "Nutrition Professionals" },
  { value: "medical_imaging_professionals", label: "Medical Imaging Professionals" },
  { value: "occupational_environmental_health_professionals", label: "Occupational and Environmental Health Professionals" },
  { value: "optometrists_orthoptists", label: "Optometrists and Orthoptists" },
  { value: "pharmacists", label: "Pharmacists" },
  { value: "other_health_diagnostic_promotion_professionals", label: "Other Health Diagnostic and Promotion Professionals" },
  { value: "chiropractors_osteopaths", label: "Chiropractors and Osteopaths" },
  { value: "complementary_health_therapists", label: "Complementary Health Therapists" },
  { value: "dental_practitioners", label: "Dental Practitioners" },
  { value: "occupational_therapists", label: "Occupational Therapists" },
  { value: "physiotherapists", label: "Physiotherapists" },
  { value: "podiatrists", label: "Podiatrists" },
  { value: "audiologists_speech_pathologists", label: "Audiologists and Speech Pathologists / Therapists" },
  { value: "general_practitioners_resident_medical_officers", label: "General Practitioners and Resident Medical Officers" },
  { value: "anaesthetists", label: "Anaesthetists" },
  { value: "specialist_physicians", label: "Specialist Physicians" },
  { value: "psychiatrists", label: "Psychiatrists" },
  { value: "surgeons", label: "Surgeons" },
  { value: "other_medical_practitioners", label: "Other Medical Practitioners" },
  { value: "midwives", label: "Midwives" },
  { value: "nurse_educators_researchers", label: "Nurse Educators and Researchers" },
  { value: "nurse_managers", label: "Nurse Managers" },
  { value: "registered_nurses", label: "Registered Nurses" },
  { value: "ict_business_systems_analysts", label: "ICT Business and Systems Analysts" },
  { value: "multimedia_specialists_web_developers", label: "Multimedia Specialists and Web Developers" },
  { value: "software_applications_programmers", label: "Software and Applications Programmers" },
  { value: "database_systems_administrators_ict_security", label: "Database and Systems Administrators, and ICT Security Specialists" },
  { value: "computer_network_professionals", label: "Computer Network Professionals" },
  { value: "ict_support_test_engineers", label: "ICT Support and Test Engineers" },
  { value: "telecommunications_engineering_professionals", label: "Telecommunications Engineering Professionals" },
  { value: "barristers", label: "Barristers" },
  { value: "judicial_other_legal_professionals", label: "Judicial and Other Legal Professionals" },
  { value: "solicitors", label: "Solicitors" },
  { value: "counsellors", label: "Counsellors" },
  { value: "ministers_religion", label: "Ministers of Religion" },
  { value: "psychologists_psychotherapists", label: "Psychologists and Psychotherapists" },
  { value: "social_professionals", label: "Social Professionals" },
  { value: "social_workers", label: "Social Workers" },
  { value: "welfare_recreation_community_arts_workers", label: "Welfare, Recreation and Community Arts Workers" },
  { value: "agricultural_technicians", label: "Agricultural Technicians" },
  { value: "medical_technicians", label: "Medical Technicians" },
  { value: "primary_products_inspectors", label: "Primary Products Inspectors" },
  { value: "science_technicians", label: "Science Technicians" },
  { value: "architectural_building_surveying_technicians", label: "Architectural, Building and Surveying Technicians" },
  { value: "civil_engineering_draftspersons_technicians", label: "Civil Engineering Draftspersons and Technicians" },
  { value: "electrical_engineering_draftspersons_technicians", label: "Electrical Engineering Draftspersons, Technicians" },
  { value: "electronic_engineering_draftspersons_technicians", label: "Electronic Engineering Draftspersons, Technicians" },
  { value: "mechanical_engineering_draftspersons_technicians", label: "Mechanical Engineering Draftspersons, Technicians" },
  { value: "safety_inspectors", label: "Safety Inspectors" },
  { value: "other_building_engineering_technicians", label: "Other Building and Engineering Technicians" },
  { value: "ict_support_technicians", label: "ICT Support Technicians" },
  { value: "telecommunications_technical_specialists", label: "Telecommunications Technical Specialists" },
  { value: "automotive_electricians", label: "Automotive Electricians" },
  { value: "motor_mechanics", label: "Motor Mechanics" },
  { value: "metal_casting_forging_finishing_trades", label: "Metal Casting, Forging and Finishing Trades" },
  { value: "sheetmetal_trades_workers", label: "Sheetmetal Trades Workers" },
  { value: "structural_steel_welding_trades_workers", label: "Structural Steel and Welding Trades Workers" },
  { value: "aircraft_maintenance_engineers", label: "Aircraft Maintenance Engineers" },
  { value: "metal_fitters_machinists", label: "Metal Fitters and Machinists" },
  { value: "precision_metal_trades_workers", label: "Precision Metal Trades Workers" },
  { value: "toolmakers_engineering_patternmakers", label: "Toolmakers and Engineering Patternmakers" },
  { value: "panelbeaters", label: "Panelbeaters" },
  { value: "vehicle_body_builders_trimmers", label: "Vehicle Body Builders and Trimmers" },
  { value: "vehicle_painters", label: "Vehicle Painters" },
  { value: "bricklayers_stonemasons", label: "Bricklayers and Stonemasons" },
  { value: "carpenters_joiners", label: "Carpenters and Joiners" },
  { value: "floor_finishers", label: "Floor Finishers" },
  { value: "painting_trades_workers", label: "Painting Trades Workers" },
  { value: "glaziers", label: "Glaziers" },
  { value: "plasterers", label: "Plasterers" },
  { value: "roof_tilers", label: "Roof Tilers" },
  { value: "wall_floor_tilers", label: "Wall and Floor Tilers" },
  { value: "plumbers", label: "Plumbers" },
  { value: "electricians", label: "Electricians" },
  { value: "airconditioning_refrigeration_mechanics", label: "Airconditioning and Refrigeration Mechanics" },
  { value: "electrical_distribution_trades_workers", label: "Electrical Distribution Trades Workers" },
  { value: "electronics_trades_workers", label: "Electronics Trades Workers" },
  { value: "telecommunications_trades_workers", label: "Telecommunications Trades Workers" },
  { value: "bakers_pastrycooks", label: "Bakers and Pastrycooks" },
  { value: "butchers_smallgoods_makers", label: "Butchers and Smallgoods Makers" },
  { value: "chefs", label: "Chefs" },
  { value: "cooks", label: "Cooks" },
  { value: "animal_attendants_trainers", label: "Animal Attendants and Trainers" },
  { value: "shearers", label: "Shearers" },
  { value: "veterinary_nurses", label: "Veterinary Nurses" },
  { value: "florists", label: "Florists" },
  { value: "gardeners", label: "Gardeners" },
  { value: "greenkeepers", label: "Greenkeepers" },
  { value: "nurserypersons", label: "Nurserypersons" },
  { value: "hairdressers", label: "Hairdressers" },
  { value: "print_finishers_screen_printers", label: "Print Finishers and Screen Printers" },
  { value: "graphic_pre_press_trades_workers", label: "Graphic Pre-press Trades Workers" },
  { value: "printers", label: "Printers" },
  { value: "canvas_leather_goods_makers", label: "Canvas and Leather Goods Makers" },
  { value: "clothing_trades_workers", label: "Clothing Trades Workers" },
  { value: "upholsterers", label: "Upholsterers" },
  { value: "cabinetmakers", label: "Cabinetmakers" },
  { value: "wood_machinists_wood_trades_workers", label: "Wood Machinists and Other Wood Trades Workers" },
  { value: "boat_builders_shipwrights", label: "Boat Builders and Shipwrights" },
  { value: "chemical_gas_petroleum_power_plant_operators", label: "Chemical, Gas, Petroleum and Power Plant Operators" },
  { value: "gallery_library_museum_technicians", label: "Gallery, Library and Museum Technicians" },
  { value: "jewellers", label: "Jewellers" },
  { value: "performing_arts_technicians", label: "Performing Arts Technicians" },
  { value: "signwriters", label: "Signwriters" },
  { value: "other_miscellaneous_technicians_trades_workers", label: "Other Miscellaneous Technicians and Trades Workers" },
  { value: "ambulance_officers_paramedics", label: "Ambulance Officers and Paramedics" },
  { value: "dental_hygienists_technicians_therapists", label: "Dental Hygienists, Technicians and Therapists" },
  { value: "diversional_therapists", label: "Diversional Therapists" },
  { value: "enrolled_mothercraft_nurses", label: "Enrolled and Mothercraft Nurses" },
  { value: "indigenous_health_workers", label: "Indigenous Health Workers" },
  { value: "massage_therapists", label: "Massage Therapists" },
  { value: "welfare_support_workers", label: "Welfare Support Workers" },
  { value: "child_carers", label: "Child Carers" },
  { value: "education_aides", label: "Education Aides" },
  { value: "aged_disabled_carers", label: "Aged and Disabled Carers" },
  { value: "dental_assistants", label: "Dental Assistants" },
  { value: "nursing_support_personal_care_workers", label: "Nursing Support and Personal Care Workers" },
  { value: "special_care_workers", label: "Special Care Workers" },
  { value: "bar_attendants_baristas", label: "Bar Attendants and Baristas" },
  { value: "cafe_workers", label: "Cafe Workers" },
  { value: "gaming_workers", label: "Gaming Workers" },
  { value: "hotel_service_managers", label: "Hotel Service Managers" },
  { value: "waiters", label: "Waiters" },
  { value: "other_hospitality_workers", label: "Other Hospitality Workers" },
  { value: "defence_force_members_other_ranks", label: "Defence Force Members - Other Ranks" },
  { value: "fire_emergency_workers", label: "Fire and Emergency Workers" },
  { value: "police", label: "Police" },
  { value: "prison_officers", label: "Prison Officers" },
  { value: "security_officers_guards", label: "Security Officers and Guards" },
  { value: "beauty_therapists", label: "Beauty Therapists" },
  { value: "driving_instructors", label: "Driving Instructors" },
  { value: "funeral_workers", label: "Funeral Workers" },
  { value: "gallery_museum_tour_guides", label: "Gallery, Museum and Tour Guides" },
  { value: "personal_care_consultants", label: "Personal Care Consultants" },
  { value: "tourism_travel_advisers", label: "Tourism and Travel Advisers" },
  { value: "travel_attendants", label: "Travel Attendants" },
  { value: "other_personal_service_workers", label: "Other Personal Service Workers" },
  { value: "fitness_instructors", label: "Fitness Instructors" },
  { value: "outdoor_adventure_guides", label: "Outdoor Adventure Guides" },
  { value: "sports_coaches_instructors_officials", label: "Sports Coaches, Instructors and Officials" },
  { value: "sportspersons", label: "Sportspersons" },
  { value: "contract_program_project_administrators", label: "Contract, Program and Project Administrators" },
  { value: "office_managers", label: "Office Managers" },
  { value: "practice_managers", label: "Practice Managers" },
  { value: "personal_assistants", label: "Personal Assistants" },
  { value: "secretaries", label: "Secretaries" },
  { value: "general_clerks", label: "General Clerks" },
  { value: "keyboard_operators", label: "Keyboard Operators" },
  { value: "call_contact_centre_workers", label: "Call or Contact Centre Workers" },
  { value: "information_officers", label: "Information Officers" },
  { value: "receptionists", label: "Receptionists" },
  { value: "accounting_clerks", label: "Accounting Clerks" },
  { value: "bookkeepers", label: "Bookkeepers" },
  { value: "payroll_clerks", label: "Payroll Clerks" },
  { value: "bank_workers", label: "Bank Workers" },
  { value: "credit_loans_officers", label: "Credit and Loans Officers" },
  { value: "insurance_money_market_statistical_clerks", label: "Insurance, Money Market and Statistical Clerks" },
  { value: "betting_clerks", label: "Betting Clerks" },
  { value: "couriers_postal_deliverers", label: "Couriers and Postal Deliverers" },
  { value: "filing_registry_clerks", label: "Filing and Registry Clerks" },
  { value: "mail_sorters", label: "Mail Sorters" },
  { value: "survey_interviewers", label: "Survey Interviewers" },
  { value: "switchboard_operators", label: "Switchboard Operators" },
  { value: "other_clerical_office_support_workers", label: "Other Clerical and Office Support Workers" },
  { value: "purchasing_supply_logistics_clerks", label: "Purchasing and Supply Logistics Clerks" },
  { value: "transport_despatch_clerks", label: "Transport and Despatch Clerks" },
  { value: "conveyancers_legal_executives", label: "Conveyancers and Legal Executives" },
  { value: "court_legal_clerks", label: "Court and Legal Clerks" },
  { value: "debt_collectors", label: "Debt Collectors" },
  { value: "human_resource_clerks", label: "Human Resource Clerks" },
  { value: "inspectors_regulatory_officers", label: "Inspectors and Regulatory Officers" },
  { value: "insurance_investigators_loss_adjusters", label: "Insurance Investigators, Loss Adjusters and Risk Surveyors" },
  { value: "library_assistants", label: "Library Assistants" },
  { value: "other_miscellaneous_clerical_administrative_workers", label: "Other Miscellaneous Clerical and Administrative Workers" },
  { value: "auctioneers_stock_station_agents", label: "Auctioneers, and Stock and Station Agents" },
  { value: "insurance_agents", label: "Insurance Agents" },
  { value: "sales_representatives", label: "Sales Representatives" },
  { value: "real_estate_sales_agents", label: "Real Estate Sales Agents" },
  { value: "sales_assistants_general", label: "Sales Assistants (General)" },
  { value: "ict_sales_assistants", label: "ICT Sales Assistants" },
  { value: "motor_vehicle_parts_salespersons", label: "Motor Vehicle and Vehicle Parts Salespersons" },
  { value: "pharmacy_sales_assistants", label: "Pharmacy Sales Assistants" },
  { value: "retail_supervisors", label: "Retail Supervisors" },
  { value: "service_station_attendants", label: "Service Station Attendants" },
  { value: "street_vendors_salespersons", label: "Street Vendors and Related Salespersons" },
  { value: "other_sales_assistants_salespersons", label: "Other Sales Assistants and Salespersons" },
  { value: "checkout_operators_office_cashiers", label: "Checkout Operators and Office Cashiers" },
  { value: "models_sales_demonstrators", label: "Models and Sales Demonstrators" },
  { value: "retail_wool_buyers", label: "Retail and Wool Buyers" },
  { value: "telemarketers", label: "Telemarketers" },
  { value: "ticket_salespersons", label: "Ticket Salespersons" },
  { value: "visual_merchandisers", label: "Visual Merchandisers" },
  { value: "other_sales_support_workers", label: "Other Sales Support Workers" },
  { value: "clay_concrete_glass_stone_processing", label: "Clay, Concrete, Glass and Stone Processing Machine Operators" },
  { value: "industrial_spraypainters", label: "Industrial Spraypainters" },
  { value: "paper_wood_processing_machine_operators", label: "Paper and Wood Processing Machine Operators" },
  { value: "photographic_developers_printers", label: "Photographic Developers and Printers" },
  { value: "plastics_rubber_production_machine_operators", label: "Plastics and Rubber Production Machine Operators" },
  { value: "sewing_machinists", label: "Sewing Machinists" },
  { value: "textile_footwear_production_machine_operators", label: "Textile and Footwear Production Machine Operators" },
  { value: "other_machine_operators", label: "Other Machine Operators" },
  { value: "crane_hoist_lift_operators", label: "Crane, Hoist and Lift Operators" },
  { value: "drillers_miners_shot_firers", label: "Drillers, Miners and Shot Firers" },
  { value: "engineering_production_workers", label: "Engineering Production Workers" },
  { value: "other_stationary_plant_operators", label: "Other Stationary Plant Operators" },
  { value: "agricultural_forestry_horticultural_plant_operators", label: "Agricultural, Forestry and Horticultural Plant Operators" },
  { value: "earthmoving_plant_operators", label: "Earthmoving Plant Operators" },
  { value: "forklift_drivers", label: "Forklift Drivers" },
  { value: "other_mobile_plant_operators", label: "Other Mobile Plant Operators" },
  { value: "automobile_drivers", label: "Automobile Drivers" },
  { value: "bus_coach_drivers", label: "Bus and Coach Drivers" },
  { value: "train_tram_drivers", label: "Train and Tram Drivers" },
  { value: "delivery_drivers", label: "Delivery Drivers" },
  { value: "truck_drivers", label: "Truck Drivers" },
  { value: "storepersons", label: "Storepersons" },
  { value: "car_detailers", label: "Car Detailers" },
  { value: "commercial_cleaners", label: "Commercial Cleaners" },
  { value: "domestic_cleaners", label: "Domestic Cleaners" },
  { value: "housekeepers", label: "Housekeepers" },
  { value: "laundry_workers", label: "Laundry Workers" },
  { value: "other_cleaners", label: "Other Cleaners" },
  { value: "building_plumbing_labourers", label: "Building and Plumbing Labourers" },
  { value: "concreters", label: "Concreters" },
  { value: "fencers", label: "Fencers" },
  { value: "insulation_home_improvement_installers", label: "Insulation and Home Improvement Installers" },
  { value: "paving_surfacing_labourers", label: "Paving and Surfacing Labourers" },
  { value: "railway_track_workers", label: "Railway Track Workers" },
  { value: "structural_steel_construction_workers", label: "Structural Steel Construction Workers" },
  { value: "other_construction_mining_labourers", label: "Other Construction and Mining Labourers" },
  { value: "food_drink_factory_workers", label: "Food and Drink Factory Workers" },
  { value: "meat_boners_slicers_slaughterers", label: "Meat Boners and Slicers, and Slaughterers" },
  { value: "meat_poultry_seafood_process_workers", label: "Meat, Poultry and Seafood Process Workers" },
  { value: "packers", label: "Packers" },
  { value: "product_assemblers", label: "Product Assemblers" },
  { value: "metal_engineering_process_workers", label: "Metal Engineering Process Workers" },
  { value: "plastics_rubber_factory_workers", label: "Plastics and Rubber Factory Workers" },
  { value: "product_quality_controllers", label: "Product Quality Controllers" },
  { value: "timber_wood_process_workers", label: "Timber and Wood Process Workers" },
  { value: "other_factory_process_workers", label: "Other Factory Process Workers" },
  { value: "aquaculture_workers", label: "Aquaculture Workers" },
  { value: "crop_farm_workers", label: "Crop Farm Workers" },
  { value: "forestry_logging_workers", label: "Forestry and Logging Workers" },
  { value: "garden_nursery_labourers", label: "Garden and Nursery Labourers" },
  { value: "livestock_farm_workers", label: "Livestock Farm Workers" },
  { value: "mixed_crop_livestock_farm_workers", label: "Mixed Crop and Livestock Farm Workers" },
  { value: "other_farm_forestry_garden_workers", label: "Other Farm, Forestry and Garden Workers" },
  { value: "fast_food_cooks", label: "Fast Food Cooks" },
  { value: "food_trades_assistants", label: "Food Trades Assistants" },
  { value: "kitchenhands", label: "Kitchenhands" },
  { value: "freight_furniture_handlers", label: "Freight and Furniture Handlers" },
  { value: "shelf_fillers", label: "Shelf Fillers" },
  { value: "caretakers", label: "Caretakers" },
  { value: "deck_fishing_hands", label: "Deck and Fishing Hands" },
  { value: "handypersons", label: "Handypersons" },
  { value: "motor_vehicle_parts_accessories_fitters", label: "Motor Vehicle Parts and Accessories Fitters" },
  { value: "printing_assistants_table_workers", label: "Printing Assistants and Table Workers" },
  { value: "recycling_rubbish_collectors", label: "Recycling and Rubbish Collectors" },
  { value: "vending_machine_attendants", label: "Vending Machine Attendants" },
  { value: "other_miscellaneous_labourers", label: "Other Miscellaneous Labourers" },
  // Note: This is a sample of the first 200 business types. 
  // The complete list would include all 2136 business types as provided.
  // For brevity, I've included the most common categories.
  // You can add the remaining business types following the same pattern.
  { value: "other", label: "Other" }
];

const CreateAgentForm = ({ onClose, onSuccess, userEmail, userId, onOpenAssistant }) => {
  const [formData, setFormData] = useState({
    emailId: '', // Email ID field - empty by default, user must enter email
    businessName: '',
    businessType: '',
    businessDescription: '',
    businessHours: '',
    timeZone: '',
    agentName: '',
    agentPersonality: '',
    voiceGender: 'female', // Default voice gender for server
    language: 'en-US', // Default language for server
    greetingMessage: '',
    primaryServices: '',
    commonQuestions: '',
    appointmentTypes: '',
    capabilities: [],
    transferScenarios: '',
    transferNumber: '',
    afterHoursMessage: '',
    maxCallDuration: '10',
    silenceTimeout: '30',
    webhookUrl: '',
    calendarIntegration: '',
    additionalInstructions: '',
    useType: '', // 'personal' or 'business'
    personalReason: '', // for personal use cases
    // New fields for storing type, occupation_title, and reason
    type: '', // 'personal' or 'business'
    occupation_title: '', // business type/occupation_title name
    reason: '' // personal reason or business description
  });

  const [showAdvanced, setShowAdvanced] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  
  // Description choice modal state
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [modalContext, setModalContext] = useState(null);
  const [showDescriptionField, setShowDescriptionField] = useState(false);
  const [promptData, setPromptData] = useState(null);
  const [loadingPrompt, setLoadingPrompt] = useState(false);
  
  // AI Assistant popup state
  const [showAIAssistantPopup, setShowAIAssistantPopup] = useState(false);
  const [aiAssistantContext, setAiAssistantContext] = useState(null);
  
  // Phone number purchasing state
  const [isPurchasingPhone, setIsPurchasingPhone] = useState(false);
  const [phonePurchaseStatus, setPhonePurchaseStatus] = useState('');
  const [purchasedPhoneNumber, setPurchasedPhoneNumber] = useState(null);
  const [showPhonePurchasePopup, setShowPhonePurchasePopup] = useState(false);
  
  // Phone number selection state (existing vs buy new)
  const [showPhoneNumberSelection, setShowPhoneNumberSelection] = useState(false);
  const [phoneNumberOption, setPhoneNumberOption] = useState(''); // 'existing' or 'buy-new'
  const [availablePhoneNumbers, setAvailablePhoneNumbers] = useState([]);
  const [selectedExistingPhoneNumber, setSelectedExistingPhoneNumber] = useState('');
  const [loadingPhoneNumbers, setLoadingPhoneNumbers] = useState(false);
  
  // User emails state for dropdown
  const [availableEmails, setAvailableEmails] = useState([]);
  const [loadingEmails, setLoadingEmails] = useState(false);
  const [showCustomEmailInput, setShowCustomEmailInput] = useState(false);
  
  // Verified Numbers popup state
  const [showVerifiedNumbersPopup, setShowVerifiedNumbersPopup] = useState(false);
  const [verifiedNumbersData, setVerifiedNumbersData] = useState([]);
  
  // Add New Verified Number form state
  const [showAddVerifiedForm, setShowAddVerifiedForm] = useState(false);
  const [newVerifiedNumber, setNewVerifiedNumber] = useState({
    user_name: '',
    phone_number: ''
  });
  const [isAddingVerified, setIsAddingVerified] = useState(false);
  
  // Call Transfer popup state
  const [showCallTransferPopup, setShowCallTransferPopup] = useState(false);
  
  // Progress Bar Popup state
  const [showProgressPopup, setShowProgressPopup] = useState(false);
  const [progressValue, setProgressValue] = useState(0);
  const [progressMessage, setProgressMessage] = useState('Preparing your agent...');
  const [countdownSeconds, setCountdownSeconds] = useState(10);
  
  // Expose showCallTransferPopup function to window for VerifiedNumbers component
  useEffect(() => {
    window.showCallTransferPopup = () => {
      console.log('🔍 [CREATE AGENT FORM] showCallTransferPopup called from window');
      setShowCallTransferPopup(true);
    };
    
    return () => {
      delete window.showCallTransferPopup;
    };
  }, []);

  // Monitor VerifiedNumbers popup state changes
  useEffect(() => {
    console.log('🔍 [CREATE AGENT FORM] showVerifiedNumbersPopup state changed to:', showVerifiedNumbersPopup);
  }, [showVerifiedNumbersPopup]);
  
  // Fetch available user emails on component mount
  useEffect(() => {
    const fetchUserEmails = async () => {
      setLoadingEmails(true);
      try {
        console.log('📧 [CREATE AGENT FORM] Fetching user emails from:', `${API_BASE_URL}/api/user-emails`);
        const response = await fetch(`${API_BASE_URL}/api/user-emails`);
        if (response.ok) {
          const emails = await response.json();
          console.log('📧 [CREATE AGENT FORM] Fetched user emails:', emails);
          setAvailableEmails(emails);
          console.log('📧 [CREATE AGENT FORM] Total emails fetched:', emails.length);
        } else {
          const errorText = await response.text();
          console.error('❌ [CREATE AGENT FORM] Failed to fetch user emails. Status:', response.status, 'Error:', errorText);
          setAvailableEmails([]);
        }
      } catch (error) {
        console.error('❌ [CREATE AGENT FORM] Error fetching user emails:', error);
        setAvailableEmails([]);
      } finally {
        setLoadingEmails(false);
      }
    };
    
    fetchUserEmails();
  }, []);
  
  const [transferPhoneNumber, setTransferPhoneNumber] = useState('');
  const [transferType, setTransferType] = useState('cold');

  // Progress Bar Animation Effect
  useEffect(() => {
    if (!showProgressPopup) return;

    // Reset progress when popup opens
    setProgressValue(0);
    setCountdownSeconds(10);
    setProgressMessage('Preparing your agent...');

    // Progress bar animation
    const progressInterval = setInterval(() => {
      setProgressValue(prev => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          return 100;
        }
        // Increment by random amount between 2-5% for smooth progress
        const increment = Math.random() * 3 + 2;
        return Math.min(prev + increment, 100);
      });
    }, 200);

    // Countdown timer
    const countdownInterval = setInterval(() => {
      setCountdownSeconds(prev => {
        if (prev <= 0) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // Update progress messages based on progress value
    const messageInterval = setInterval(() => {
      setProgressValue(current => {
        if (current < 30) {
          setProgressMessage('Preparing your agent...');
        } else if (current < 60) {
          setProgressMessage('Configuring phone number...');
        } else if (current < 90) {
          setProgressMessage('Processing verified numbers...');
        } else {
          setProgressMessage('Finalizing setup...');
        }
        return current;
      });
    }, 500);

    // Cleanup and completion
    const completionTimeout = setTimeout(() => {
      clearInterval(progressInterval);
      clearInterval(countdownInterval);
      clearInterval(messageInterval);
      setProgressValue(100);
      setCountdownSeconds(0);
      setProgressMessage('Setup complete! Your agent is ready.');
      
      // Close popup and form after 2 seconds
      setTimeout(() => {
        setShowProgressPopup(false);
        if (onSuccess) {
          // Get the agent data from localStorage if available
          const createdAgentData = JSON.parse(localStorage.getItem('lastCreatedAgent'));
          onSuccess({ agent: createdAgentData });
        }
        if (onClose) onClose();
      }, 2000);
    }, 10000); // 10 seconds total

    return () => {
      clearInterval(progressInterval);
      clearInterval(countdownInterval);
      clearInterval(messageInterval);
      clearTimeout(completionTimeout);
    };
  }, [showProgressPopup, onSuccess, onClose]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      if (name === 'capabilities') {
        setFormData(prev => ({
          ...prev,
          capabilities: checked 
            ? [...prev.capabilities, value]
            : prev.capabilities.filter(cap => cap !== value)
        }));
      }
    } else {
      setFormData(prev => {
        const updatedData = {
          ...prev,
          [name]: value
        };
        
        // Update the new fields based on useType and related fields
        if (name === 'useType') {
          updatedData.type = value;
          // Clear occupation_title and reason when useType changes
          updatedData.occupation_title = '';
          updatedData.reason = '';
        } else if (name === 'businessType') {
          // When business type is selected, store it as occupation_title
          updatedData.occupation_title = value;
          // Also update reason with business description if available
          if (prev.businessDescription) {
            updatedData.reason = prev.businessDescription;
          }
        } else if (name === 'personalReason') {
          // When personal reason is entered, store it as reason
          updatedData.reason = value;
        } else if (name === 'businessDescription') {
          // When business description is entered, store it as reason
          updatedData.reason = value;
        }
        
        return updatedData;
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    // Normalize email to lowercase for case-insensitive handling
    const normalizedUserEmail = userEmail ? userEmail.toLowerCase().trim() : userEmail;
    
    console.log('🚀 [CREATE AGENT FORM] Starting agent creation with userEmail:', normalizedUserEmail);
    console.log('📊 [CREATE AGENT FORM] Form data:', formData);
    console.log('📊 [CREATE AGENT FORM] Business description length:', formData.businessDescription?.length || 0);
    console.log('📊 [CREATE AGENT FORM] Business name:', formData.businessName);
    console.log('📊 [CREATE AGENT FORM] Agent name:', formData.agentName);

    // Validate phone number selection if phone number selection is shown
    if (showPhoneNumberSelection) {
      if (!phoneNumberOption) {
        setError('Please select whether to use an existing phone number or buy a new one');
        setIsSubmitting(false);
        return;
      }
      if (phoneNumberOption === 'existing' && !selectedExistingPhoneNumber) {
        setError('Please select an existing phone number');
        setIsSubmitting(false);
        return;
      }
    }

    // Prepare the data to be sent to the database
    const submissionData = {
      ...formData,
      emailId: formData.emailId || normalizedUserEmail, // Use form emailId or fallback to normalizedUserEmail
      userEmail: formData.emailId || normalizedUserEmail, // Use form emailId for userEmail as well
      userId: userId, // Include user ID for proper database tracking
      // Ensure the new fields are properly set before submission
      type: formData.useType, // 'personal' or 'business'
      occupation_title: formData.useType === 'business' ? formData.businessType : '', // business type/occupation_title name
      reason: formData.useType === 'personal' ? formData.personalReason : formData.businessDescription, // personal reason or business description
      // Ensure voice configuration is set
      voiceGender: formData.voiceGender || 'female',
      language: formData.language || 'en-US',
      // Set default business name if not provided
      businessName: formData.businessName || (formData.useType === 'personal' ? 'Personal Assistant' : 'My Business'),
      // Include phone number selection if using existing phone
      useExistingPhoneNumber: phoneNumberOption === 'existing',
      selectedExistingPhoneNumber: phoneNumberOption === 'existing' ? selectedExistingPhoneNumber : null
    };

    console.log('📤 [CREATE AGENT FORM] Submission data:', submissionData);

    // Show phone purchase popup immediately before making API call
    setShowPhonePurchasePopup(true);

    try {
      // Log the API URL being used for debugging
      const apiUrl = `${API_BASE_URL}/api/create-agent`;
      console.log('🌐 [CREATE AGENT FORM] API URL:', apiUrl);
      console.log('🌐 [CREATE AGENT FORM] API_BASE_URL:', API_BASE_URL);
      
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'user-email': normalizedUserEmail
        },
        body: JSON.stringify(submissionData)
      });

      // Check if response is ok before parsing JSON
      if (!response.ok) {
        console.error('❌ [CREATE AGENT FORM] API Error Response:', {
          status: response.status,
          statusText: response.statusText,
          url: apiUrl
        });
        
        // Try to get error message from response
        let errorMessage = `Server responded with status ${response.status}`;
        try {
          const errorData = await response.json();
          errorMessage = errorData.error || errorData.message || errorMessage;
        } catch (e) {
          // If JSON parsing fails, use status text
          errorMessage = response.statusText || errorMessage;
        }
        
        throw new Error(errorMessage);
      }

      const result = await response.json();
      
      console.log('🔍 [CREATE AGENT FORM] Full response received:', result);
      console.log('🔍 [CREATE AGENT FORM] Response keys:', Object.keys(result));
      console.log('🔍 [CREATE AGENT FORM] Phone number data:', {
        phoneNumber: result.phoneNumber,
        testPhoneNumber: result.testPhoneNumber,
        existingPhoneNumber: result.existingPhoneNumber,
        phonePurchaseError: result.phonePurchaseError
      });
      
      // Handle phone purchase failure - backend returns 400 status when phone purchase fails
      if (!response.ok && result.phonePurchaseError) {
        console.error('❌ [CREATE AGENT FORM] Phone number purchase failed:', result.phonePurchaseError);
        setIsPurchasingPhone(false);
        setShowPhonePurchasePopup(false);
        setError(result.message || 'Phone number purchase failed. Please try again or contact support.');
        alert(`Agent creation failed!\n\nError: ${result.message || 'Phone number purchase failed'}\n\nDetails: ${result.phonePurchaseError}\n\nPlease try again or contact support.`);
        return;
      }
      
      // Handle phone purchase or database storage failure even if response is ok
      if (result.phonePurchaseError && !result.phoneNumber && !result.testPhoneNumber && !result.existingPhoneNumber) {
        console.error('❌ [CREATE AGENT FORM] Phone number purchase or storage failed:', result.phonePurchaseError);
        setIsPurchasingPhone(false);
        setShowPhonePurchasePopup(false);
        setError(result.message || 'Phone number setup failed. Please try again or contact support.');
        alert(`Agent creation failed!\n\nError: ${result.message || 'Phone number setup failed'}\n\nDetails: ${result.phonePurchaseError}\n\nPlease try again or contact support.`);
        return;
      }
      
      // Close phone purchase popup when response is received
      setShowPhonePurchasePopup(false);
      
      if (response.ok && result.success) {
        // Show phone number purchasing status
        setIsPurchasingPhone(true);
        setPhonePurchaseStatus('Setting up phone number for testing...');
        
        // Check if phone number was purchased, existing, or test phone number
        if (result.phoneNumber || result.testPhoneNumber || result.existingPhoneNumber) {
          const phoneData = result.phoneNumber || result.testPhoneNumber || result.existingPhoneNumber;
          const phoneNumberToDisplay = phoneData.phone_number || phoneData.phoneNumber || phoneData.phone_numbers;
          
          // Check if phone number was successfully stored in database - do not proceed if not stored
          if (!phoneData.databaseRecord) {
            console.error('❌ [CREATE AGENT FORM] Phone number was not stored in database');
            setIsPurchasingPhone(false);
            setError('Phone number was not stored in database. Please try again or contact support.');
            alert(`Agent creation failed!\n\nError: Phone number was not stored in database\n\nPlease try again or contact support.`);
            return;
          }
          
          // Display the phone number that is being bought to the user before VerifiedNumbers popup
          if (phoneNumberToDisplay) {
            setPhonePurchaseStatus(`Phone number purchased successfully: ${phoneNumberToDisplay}. Opening verification popup now...`);
            // Show alert with the purchased phone number
            alert(`Phone number purchased successfully!\n\nPhone Number: ${phoneNumberToDisplay}\n\nYou will now be redirected to add verified numbers.`);
          } else {
            setPhonePurchaseStatus('Phone number setup completed successfully! Opening verification popup now...');
          }
          
          setPurchasedPhoneNumber(phoneData);
          
          // Note: The backend automatically stores the agent_id as both inbound_agent_id and outbound_agent_id
          // in the phone_numbers table when creating/purchasing phone numbers
          
          // Store agent data in localStorage for later use in call transfer setup
          if (result.agent && result.agent.agent_id) {
            localStorage.setItem('lastCreatedAgent', JSON.stringify({
              agent_id: result.agent.agent_id,
              agent_name: result.agent.agent_name || formData.agentName,
              llm_id: result.agent.llm_id,
              created_at: new Date().toISOString()
            }));
            console.log('💾 Stored agent data in localStorage for call transfer setup');
            console.log('🔗 Agent ID will be stored as inbound_agent_id and outbound_agent_id in phone_numbers table:', result.agent.agent_id);
          }
          
          // Note: We don't automatically store phone numbers in verified_numbers table
          // The user will manually add verified numbers through the Verified Numbers popup
          console.log('📋 Phone number ready - user will add verified numbers manually through popup');
          console.log('📞 [CREATE AGENT FORM] Phone number being bought:', phoneNumberToDisplay);
          console.log('💾 [CREATE AGENT FORM] Phone number database record:', phoneData.databaseRecord);
          
          // Fetch verified numbers data
          await fetchVerifiedNumbers();
          
          // Show Verified Numbers popup immediately after phone setup success
          console.log('🔍 [CREATE AGENT FORM] About to show Verified Numbers popup immediately');
          console.log('🔍 [CREATE AGENT FORM] Current showVerifiedNumbersPopup state:', showVerifiedNumbersPopup);
          setIsPurchasingPhone(false);
          setShowVerifiedNumbersPopup(true);
          console.log('🔍 [CREATE AGENT FORM] Verified Numbers popup state set to true');
          console.log('🔍 [CREATE AGENT FORM] Verified Numbers popup should now be visible');
        } else if (result.success && result.agent) {
          // Even if no phone number was set up, show the popup if agent was created successfully
          // This ensures users can still see verified numbers and set up call transfer
          console.log('📞 No phone number setup, but agent created successfully - showing verified numbers popup');
          
          // Store agent data in localStorage for later use in call transfer setup
          if (result.agent && result.agent.agent_id) {
            localStorage.setItem('lastCreatedAgent', JSON.stringify({
              agent_id: result.agent.agent_id,
              agent_name: result.agent.agent_name || formData.agentName,
              llm_id: result.agent.llm_id,
              created_at: new Date().toISOString()
            }));
            console.log('💾 Stored agent data in localStorage for call transfer setup');
            console.log('🔗 Agent ID will be stored as inbound_agent_id and outbound_agent_id in phone_numbers table:', result.agent.agent_id);
          }
          
          // Fetch verified numbers data
          await fetchVerifiedNumbers();
          
          // Show Verified Numbers popup immediately after agent creation success
          console.log('🔍 [CREATE AGENT FORM] About to show Verified Numbers popup immediately (no phone setup)');
          setIsPurchasingPhone(false);
          setShowVerifiedNumbersPopup(true);
          console.log('🔍 [CREATE AGENT FORM] Verified Numbers popup state set to true (no phone setup)');
        } else if (result.phonePurchaseError) {
          setPhonePurchaseStatus(`Phone setup failed: ${result.phonePurchaseError}`);
          setTimeout(() => {
            setIsPurchasingPhone(false);
            alert('Agent created successfully, but phone number setup failed. You can add a phone number later.');
            if (onSuccess) onSuccess(result);
            if (onClose) onClose();
          }, 3000);
        } else {
          // No phone number setup attempted
          setIsPurchasingPhone(false);
          alert('Agent created successfully!');
          if (onSuccess) onSuccess(result);
          if (onClose) onClose();
        }
      } else {
        setError(result.error || 'Failed to create agent');
        setIsPurchasingPhone(false);
        setShowPhonePurchasePopup(false);
      }
    } catch (err) {
      setError('Network error: ' + err.message);
      setShowPhonePurchasePopup(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  const toggleAdvanced = () => setShowAdvanced(!showAdvanced);

  // Fetch prompt data from server
  const fetchPromptData = async () => {
    setLoadingPrompt(true);
    try {
      // Normalize email to lowercase for case-insensitive handling
      const normalizedUserEmail = userEmail ? userEmail.toLowerCase().trim() : userEmail;
      
      const response = await fetch(`${API_BASE_URL}/api/fetch-prompt-data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          formData: formData,
          userEmail: normalizedUserEmail
        })
      });

      const result = await response.json();
      
      if (result.success) {
        setPromptData(result.promptData);
      } else {
        console.error('Error fetching prompt data:', result.error);
      }
    } catch (error) {
      console.error('Error fetching prompt data:', error);
    } finally {
      setLoadingPrompt(false);
    }
  };

  // Fetch available phone numbers from phone_numbers table
  const fetchAvailablePhoneNumbers = async () => {
    setLoadingPhoneNumbers(true);
    try {
      // Fetch all phone numbers from phone_numbers table (for admin use)
      // The backend will return all phone numbers from phone_numbers table
      const response = await fetch(`${API_BASE_URL}/api/phone-numbers`);
      if (response.ok) {
        const phones = await response.json();
        setAvailablePhoneNumbers(phones || []);
        console.log('📞 [CREATE AGENT FORM] Fetched available phone numbers from phone_numbers table:', phones);
        console.log('📞 [CREATE AGENT FORM] Total phone numbers available:', phones.length);
      } else {
        const errorText = await response.text();
        console.error('❌ [CREATE AGENT FORM] Failed to fetch phone numbers. Status:', response.status, 'Error:', errorText);
        setAvailablePhoneNumbers([]);
      }
    } catch (error) {
      console.error('❌ [CREATE AGENT FORM] Error fetching phone numbers:', error);
      setAvailablePhoneNumbers([]);
    } finally {
      setLoadingPhoneNumbers(false);
    }
  };

  // Handle description choice
  const handleDescriptionChoice = (choice) => {
    if (choice === 'ai-assistant') {
      // Prepare context data for the AI Assistant popup
      // Normalize email to lowercase for case-insensitive handling
      const normalizedUserEmail = userEmail ? userEmail.toLowerCase().trim() : userEmail;
      const contextData = {
        formData: formData,
        modalContext: modalContext,
        userEmail: normalizedUserEmail,
        task: 'create_description',
        message: `I need help creating a description for my ${modalContext?.useType === 'business' ? 'business' : 'personal'} AI agent. Here are the details: Agent Name: ${modalContext?.agentName}, ${modalContext?.useType === 'business' ? `Business Name: ${modalContext?.businessName}, Business Type: ${modalContext?.businessTypeLabel}` : `Personal Reason: ${modalContext?.personalReason}`}. Please help me create a comprehensive description. After creating the description, please also help me create a chatbot for the same with all the required configurations and settings.`
      };
      
      // Set the context and open the AI Assistant popup
      setAiAssistantContext(contextData);
      setShowAIAssistantPopup(true);
    } else if (choice === 'describe-yourself') {
      // Fetch prompt data and show the description field
      fetchPromptData();
      setShowDescriptionField(true);
      // Show phone number selection after description choice
      setShowPhoneNumberSelection(true);
      fetchAvailablePhoneNumbers();
    }
  };
  
  // Handle phone number option selection
  const handlePhoneNumberOption = (option) => {
    setPhoneNumberOption(option);
    if (option === 'existing') {
      fetchAvailablePhoneNumbers();
    } else {
      setSelectedExistingPhoneNumber('');
    }
  };

  // Handle AI Assistant popup close
  const handleAIAssistantPopupClose = () => {
    setShowAIAssistantPopup(false);
    setAiAssistantContext(null);
    // Show phone number selection after AI Assistant closes if description is filled
    if (formData.businessDescription && formData.businessDescription.trim() !== '') {
      setShowPhoneNumberSelection(true);
      fetchAvailablePhoneNumbers();
    }
  };

  // Handle Add New Verified Number form input changes
  const handleVerifiedNumberInputChange = (e) => {
    const { name, value } = e.target;
    setNewVerifiedNumber(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Function to store purchased phone number in verified numbers database
  const storePurchasedPhoneNumberInVerifiedNumbers = async (phoneNumberData) => {
    try {
      const user = JSON.parse(localStorage.getItem('chatbotUser'));
      if (!user || !user.userId) {
        throw new Error('User not found');
      }

      console.log('💾 Storing purchased phone number in verified numbers:', { 
        phoneNumber: phoneNumberData.phone_number, 
        userId: user.userId,
        phoneData: phoneNumberData 
      });

      const response = await fetch(`${API_BASE_URL}/api/verified-numbers`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: user.userId,
          name: `Agent Phone Number (${phoneNumberData.phone_number})`,
          phone_no: phoneNumberData.phone_number
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to store purchased phone number');
      }

      const result = await response.json();
      console.log('✅ Purchased phone number stored in verified numbers:', result);
      return result;

    } catch (error) {
      console.error('❌ Error storing purchased phone number in verified numbers:', error);
      throw error;
    }
  };

  // Handle adding new verified number
  const handleAddVerifiedNumber = async () => {
    if (!newVerifiedNumber.user_name.trim() || !newVerifiedNumber.phone_number.trim()) {
      alert('Please fill in both User Name and Phone Number');
      return;
    }

    setIsAddingVerified(true);
    try {
      const user = JSON.parse(localStorage.getItem('chatbotUser'));
      if (!user || !user.userId) {
        alert('User not found');
        return;
      }

      const response = await fetch(`${API_BASE_URL}/api/verified-numbers`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: user.userId,
          name: newVerifiedNumber.user_name,
          phone_no: newVerifiedNumber.phone_number
        })
      });

      if (response.ok) {
        // Refresh the verified numbers list
        await fetchVerifiedNumbers();
        
        // Reset form
        setNewVerifiedNumber({ user_name: '', phone_number: '' });
        setShowAddVerifiedForm(false);
        
        alert('Verified number added successfully!');
      } else {
        const errorData = await response.json();
        alert(`Failed to add verified number: ${errorData.error || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error adding verified number:', error);
      alert('Failed to add verified number. Please try again.');
    } finally {
      setIsAddingVerified(false);
    }
  };

  // Handle canceling add verified number form
  const handleCancelAddVerified = () => {
    setNewVerifiedNumber({ user_name: '', phone_number: '' });
    setShowAddVerifiedForm(false);
  };

  // Fetch verified numbers data
  const fetchVerifiedNumbers = async () => {
    try {
      const user = JSON.parse(localStorage.getItem('chatbotUser'));
      if (!user || !user.userId) {
        console.error('❌ [FETCH VERIFIED NUMBERS] User not found in localStorage');
        return;
      }

      console.log('🔍 [FETCH VERIFIED NUMBERS] Fetching verified numbers for user_id:', user.userId);

      // First, try to cleanup any corrupted data
      try {
        console.log('🧹 [FETCH VERIFIED NUMBERS] Attempting to cleanup corrupted data...');
        const cleanupResponse = await fetch(`${API_BASE_URL}/api/verified-numbers/cleanup`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            user_id: user.userId
          })
        });
        
        if (cleanupResponse.ok) {
          const cleanupResult = await cleanupResponse.json();
          console.log('🧹 [FETCH VERIFIED NUMBERS] Cleanup result:', cleanupResult);
        }
      } catch (cleanupError) {
        console.log('⚠️ [FETCH VERIFIED NUMBERS] Cleanup failed, continuing with fetch:', cleanupError);
      }

      const response = await fetch(`${API_BASE_URL}/api/verified-numbers?user_id=${user.userId}`);
      
      if (response.ok) {
        const data = await response.json();
        console.log('📞 [FETCH VERIFIED NUMBERS] Raw data received:', data);
        
        if (Array.isArray(data)) {
          // Transform database data to match our component structure
          const transformedData = data.map(item => ({
            call_id: item.user_id || Date.now().toString(),
            user_name: item.name,
            phone_number: item.phone_no,
            created_at: item.created_at || item.created_date
          }));
          
          console.log('📞 [FETCH VERIFIED NUMBERS] Transformed data:', transformedData);
          setVerifiedNumbersData(transformedData);

          // Store verified numbers in agent_phone_connection table if agent was just created
          const createdAgentData = JSON.parse(localStorage.getItem('lastCreatedAgent'));
          if (createdAgentData && createdAgentData.agent_id && transformedData.length > 0) {
            try {
              console.log('🔗 [FETCH VERIFIED NUMBERS] Storing verified numbers in agent_phone_connection table...');
              const storeResponse = await fetch(`${API_BASE_URL}/api/agents/${createdAgentData.agent_id}/store-verified-numbers`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  user_id: user.userId,
                  verified_numbers: transformedData
                })
              });

              if (storeResponse.ok) {
                const storeResult = await storeResponse.json();
                console.log('✅ [FETCH VERIFIED NUMBERS] Verified numbers stored in agent_phone_connection:', storeResult);
              } else {
                console.error('❌ [FETCH VERIFIED NUMBERS] Failed to store verified numbers in agent_phone_connection');
              }
            } catch (storeError) {
              console.error('❌ [FETCH VERIFIED NUMBERS] Error storing verified numbers in agent_phone_connection:', storeError);
            }
          }

          // Fetch and store notification phone number based on llm_id
          if (createdAgentData && createdAgentData.agent_id && createdAgentData.llm_id) {
            try {
              console.log('📱 [FETCH VERIFIED NUMBERS] Fetching notification phone number for llm_id:', createdAgentData.llm_id);
              const notificationResponse = await fetch(`${API_BASE_URL}/api/agents/${createdAgentData.agent_id}/fetch-notification-phone`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  user_id: user.userId,
                  llm_id: createdAgentData.llm_id,
                  agent_id: createdAgentData.agent_id
                })
              });

              if (notificationResponse.ok) {
                const notificationResult = await notificationResponse.json();
                console.log('✅ [FETCH VERIFIED NUMBERS] Notification phone number fetched and stored:', notificationResult);
              } else {
                console.error('❌ [FETCH VERIFIED NUMBERS] Failed to fetch notification phone number');
              }
            } catch (notificationError) {
              console.error('❌ [FETCH VERIFIED NUMBERS] Error fetching notification phone number:', notificationError);
            }
          }
        } else {
          console.log('📞 [FETCH VERIFIED NUMBERS] No verified numbers found for user');
          setVerifiedNumbersData([]);
        }
      } else {
        console.error('❌ [FETCH VERIFIED NUMBERS] Failed to fetch verified numbers, status:', response.status);
        setVerifiedNumbersData([]);
      }
    } catch (error) {
      console.error('❌ [FETCH VERIFIED NUMBERS] Error fetching verified numbers:', error);
      setVerifiedNumbersData([]);
    }
  };

  // Handle description generated by AI Assistant
  const handleDescriptionGenerated = (description) => {
    console.log('📝 [CREATE AGENT FORM] Received generated description:', description);
    
    // Ensure business name is set if it's empty
    const updatedFormData = {
      ...formData,
      businessDescription: description,
      // Ensure business name is set - use agent name if business name is empty
      businessName: formData.businessName || formData.agentName || (formData.useType === 'personal' ? 'Personal Assistant' : 'My Business')
    };
    
    console.log('📊 [CREATE AGENT FORM] Updated form data:', updatedFormData);
    
    setFormData(updatedFormData);
    setShowAIAssistantPopup(false);
    setAiAssistantContext(null);
    
    // Automatically trigger agent creation after description is generated
    console.log('🚀 [CREATE AGENT FORM] Auto-triggering agent creation with AI-generated description');
    
    // Use setTimeout to ensure state is updated before submission
    setTimeout(() => {
      // Create a mock event object to satisfy handleSubmit's preventDefault requirement
      const mockEvent = { preventDefault: () => {} };
      handleSubmit(mockEvent);
    }, 100);
  };

  // Handle description field submission
  const handleDescriptionSubmit = () => {
    if (formData.businessDescription && formData.businessDescription.trim() !== '') {
      // If phone number selection is shown, validate and submit
      if (showPhoneNumberSelection) {
        if (!phoneNumberOption) {
          setError('Please select whether to use an existing phone number or buy a new one');
          return;
        }
        if (phoneNumberOption === 'existing' && !selectedExistingPhoneNumber) {
          setError('Please select an existing phone number');
          return;
        }
        // If validation passes, proceed with submission
        setShowDescriptionModal(false);
        setShowDescriptionField(false);
        setShowPhoneNumberSelection(false);
        // Create a mock event object to satisfy handleSubmit's preventDefault requirement
        const mockEvent = { preventDefault: () => {} };
        handleSubmit(mockEvent);
      } else {
        // If phone number selection is not shown yet, show it first
        setShowPhoneNumberSelection(true);
        fetchAvailablePhoneNumbers();
      }
    }
  };

  // Modified submit handler to show description modal first
  const handleSubmitWithDescriptionCheck = (e) => {
    e.preventDefault();
    
    // Check if business description is empty
    if (!formData.businessDescription || formData.businessDescription.trim() === '') {
      // Prepare context data for the modal
      const contextData = {
        agentName: formData.agentName || 'Your Agent',
        useType: formData.useType,
        businessName: formData.businessName || '',
        businessType: formData.businessType || '',
        businessTypeLabel: formData.businessType ? businessTypes.find(type => type.value === formData.businessType)?.label || formData.businessType : '',
        personalReason: formData.personalReason || ''
      };
      
      setModalContext(contextData);
      setShowDescriptionModal(true);
      return;
    }
    
    // If description exists, proceed with normal submission
    handleSubmit(e);
  };

  // Filter business types based on search term
  const filteredBusinessTypes = businessTypes.filter(type =>
    type.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Handle business type selection
  const handleBusinessTypeSelect = (value, label) => {
    setFormData(prev => ({
      ...prev,
      businessType: value,
      occupation_title: value
    }));
    setSearchTerm(label);
    setIsDropdownOpen(false);
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setIsDropdownOpen(true);
    // Clear business type if search term is empty
    if (!e.target.value) {
      setFormData(prev => ({
        ...prev,
        businessType: '',
        occupation_title: ''
      }));
    }
  };

  // Get display label for selected business type
  const getSelectedBusinessTypeLabel = () => {
    if (!formData.businessType) return '';
    const selectedType = businessTypes.find(type => type.value === formData.businessType);
    return selectedType ? selectedType.label : '';
  };

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      {/* CSS for animations */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.05); opacity: 0.9; }
        }
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        @keyframes fadeInScale {
          0% { transform: scale(0.9); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
      
      <div style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        minHeight: '100%',
        padding: '20px',
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
      }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        background: 'white',
        borderRadius: '20px',
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
        overflow: 'visible', // Allow dropdown to extend outside
        minHeight: 'fit-content',
        position: 'relative' // Create stacking context for dropdown
      }}>
        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
          color: 'white',
          padding: '40px 30px',
          textAlign: 'center'
        }}>
          <h1 style={{ fontSize: '2.5em', marginBottom: '10px', fontWeight: '700' }}>
            🤖 Create Your AI Voice Agent
          </h1>
          <p style={{ fontSize: '1.2em', opacity: '0.9' }}>
            Transform your business with an intelligent voice assistant
          </p>
        </div>

        {/* Form Container */}
        <div style={{ 
          padding: '40px 30px',
          position: 'relative', // Create stacking context
          zIndex: 1 // Ensure content is above background
        }}>
          <form onSubmit={handleSubmitWithDescriptionCheck}>
            {/* Email ID Section - At the beginning */}
            <div style={{ marginBottom: '40px' }}>
              <h2 style={{
                fontSize: '1.5em',
                color: '#4f46e5',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e5e7eb',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <span style={{
                  width: '24px',
                  height: '24px',
                  background: '#4f46e5',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '14px'
                }}>1</span>
                  Email ID
               </h2>

              {/* Email ID Field - Dropdown */}
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                  <span>Email ID <span style={{ color: '#ef4444' }}>*</span></span>
                  <i 
                    className="fa fa-circle-info" 
                    style={{ 
                      fontSize: '16px', 
                      color: '#6b7280',
                      cursor: 'pointer',
                      transition: 'color 0.3s ease'
                    }}
                    title="Select an email address from the list"
                    onMouseEnter={(e) => {
                      e.target.style.color = '#4f46e5';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = '#6b7280';
                    }}
                  ></i>
                </label>
                {loadingEmails ? (
                  <div style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '2px solid #e5e7eb',
                    borderRadius: '10px',
                    fontSize: '16px',
                    textAlign: 'center',
                    color: '#6b7280',
                    backgroundColor: '#f9fafb'
                  }}>
                    <span style={{ marginRight: '8px' }}>⏳</span>
                    Loading emails...
                  </div>
                ) : (
                  <select
                    name="emailId"
                    value={showCustomEmailInput ? 'custom' : formData.emailId}
                    onChange={(e) => {
                      if (e.target.value === 'custom') {
                        setShowCustomEmailInput(true);
                        setFormData(prev => ({ ...prev, emailId: '' }));
                      } else {
                        setShowCustomEmailInput(false);
                        handleInputChange(e);
                      }
                    }}
                    required={!showCustomEmailInput}
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '2px solid #e5e7eb',
                      borderRadius: '10px',
                      fontSize: '16px',
                      backgroundColor: 'white',
                      cursor: 'pointer',
                      transition: 'border-color 0.3s ease',
                      appearance: 'none',
                      backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'12\' viewBox=\'0 0 12 12\'%3E%3Cpath fill=\'%234b5563\' d=\'M6 9L1 4h10z\'/%3E%3C/svg%3E")',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'right 16px center',
                      paddingRight: '40px'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#4f46e5';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e5e7eb';
                    }}
                  >
                    <option value="">-- Select an email from the list --</option>
                    {availableEmails.map((email, index) => (
                      <option key={index} value={email}>
                        {email}
                      </option>
                    ))}
                    <option value="custom">-- Enter custom email --</option>
                  </select>
                )}
                {/* Custom Email Input (shown when "Enter custom email" is selected) */}
                {showCustomEmailInput && (
                  <div style={{ marginTop: '12px' }}>
                    <input
                      type="email"
                      name="emailId"
                      value={formData.emailId}
                      onChange={handleInputChange}
                      placeholder="Enter a custom email address"
                      required
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        border: '2px solid #e5e7eb',
                        borderRadius: '10px',
                        fontSize: '16px',
                        transition: 'border-color 0.3s ease'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#4f46e5';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = '#e5e7eb';
                      }}
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Business Information Section */}
            <div style={{ marginBottom: '40px' }}>
              <h2 style={{
                fontSize: '1.5em',
                color: '#4f46e5',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e5e7eb',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <span style={{
                  width: '24px',
                  height: '24px',
                  background: '#4f46e5',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '14px'
                }}>2</span>
                  Business Information
               </h2>

                               {/* Agent Name Field - Moved to beginning */}
                <div style={{ marginBottom: '20px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                    <span>Agent Name <span style={{ color: '#ef4444' }}>*</span></span>
                    <i 
                      className="fa fa-circle-info" 
                      style={{ 
                        fontSize: '16px', 
                        color: '#6b7280',
                        cursor: 'pointer',
                        transition: 'color 0.3s ease'
                      }}
                      title="What should customers call your AI agent?"
                      onMouseEnter={(e) => {
                        e.target.style.color = '#4f46e5';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.color = '#6b7280';
                      }}
                    ></i>
                  </label>
                  <input
                    type="text"
                    name="agentName"
                    value={formData.agentName}
                    onChange={handleInputChange}
                    required
                    placeholder="e.g., Sarah, Mike, Alex"
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '2px solid #e5e7eb',
                      borderRadius: '10px',
                      fontSize: '16px',
                      transition: 'border-color 0.3s ease'
                    }}
                  />
                </div>

                                 {/* Use Type Selection */}
                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                      <span>How will you use this AI agent? <span style={{ color: '#ef4444' }}>*</span></span>
                      <i 
                        className="fa fa-circle-info" 
                        style={{ 
                          fontSize: '16px', 
                          color: '#6b7280',
                          cursor: 'pointer',
                          transition: 'color 0.3s ease'
                        }}
                        title="Select whether this is for personal or business purposes"
                        onMouseEnter={(e) => {
                          e.target.style.color = '#4f46e5';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.color = '#6b7280';
                        }}
                      ></i>
                    </label>
                    <select
                      name="useType"
                      value={formData.useType}
                      onChange={handleInputChange}
                      required
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        border: '2px solid #e5e7eb',
                        borderRadius: '10px',
                        fontSize: '16px'
                      }}
                    >
                      <option value="">Select your purpose</option>
                      <option value="personal">Personal</option>
                      <option value="business">Business</option>
                    </select>
                  </div>

                {/* Personal Reason Input */}
                {formData.useType === 'personal' && (
                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                      <span>What will you use this AI agent for? <span style={{ color: '#ef4444' }}>*</span></span>
                      <i 
                        className="fa fa-circle-info" 
                        style={{ 
                          fontSize: '16px', 
                          color: '#6b7280',
                          cursor: 'pointer',
                          transition: 'color 0.3s ease'
                        }}
                        title="Describe how you plan to use this AI agent for personal purposes"
                        onMouseEnter={(e) => {
                          e.target.style.color = '#4f46e5';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.color = '#6b7280';
                        }}
                      ></i>
                    </label>
                    <textarea
                      name="personalReason"
                      value={formData.personalReason}
                      onChange={handleInputChange}
                      required
                      placeholder="e.g., Personal assistant, learning companion, hobby project, family communication..."
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        border: '2px solid #e5e7eb',
                        borderRadius: '10px',
                        fontSize: '16px',
                        minHeight: '100px',
                        resize: 'vertical'
                      }}
                    />
                  </div>
                )}

                                                              {/* Business Type Selection */}
                {formData.useType === 'business' && (
                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                      <span>Business Type <span style={{ color: '#ef4444' }}>*</span></span>
                      <i 
                        className="fa fa-circle-info" 
                        style={{ 
                          fontSize: '16px', 
                          color: '#6b7280',
                          cursor: 'pointer',
                          transition: 'color 0.3s ease'
                        }}
                        title="Select the type of business you operate"
                        onMouseEnter={(e) => {
                          e.target.style.color = '#4f46e5';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.color = '#6b7280';
                        }}
                      ></i>
                    </label>
                    
                    {/* Searchable Dropdown Container */}
                    <div ref={dropdownRef} style={{ position: 'relative', isolation: 'isolate' }}>
                      {/* Search Input */}
                      <input
                        type="text"
                        value={searchTerm || getSelectedBusinessTypeLabel()}
                        onChange={handleSearchChange}
                        onFocus={() => setIsDropdownOpen(true)}
                        onKeyDown={(e) => {
                          if (e.key === 'Escape') {
                            setIsDropdownOpen(false);
                          }
                        }}
                        placeholder="Search or select your business type..."
                        required={formData.useType === 'business'}
                        style={{
                          width: '100%',
                          padding: '12px 16px',
                          border: '2px solid #e5e7eb',
                          borderRadius: '10px',
                          fontSize: '16px',
                          cursor: 'pointer'
                        }}
                      />
                      
                      {/* Dropdown Arrow */}
                      <i 
                        className={`fa fa-chevron-${isDropdownOpen ? 'up' : 'down'}`}
                        style={{
                          position: 'absolute',
                          right: '16px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          color: '#6b7280',
                          pointerEvents: 'none',
                          transition: 'transform 0.3s ease'
                        }}
                      ></i>
                      
                      {/* Dropdown Options */}
                      {isDropdownOpen && (
                        <div style={{
                          position: 'absolute',
                          top: '100%',
                          left: 0,
                          right: 0,
                          backgroundColor: 'white',
                          border: '2px solid #e5e7eb',
                          borderTop: 'none',
                          borderRadius: '0 0 10px 10px',
                          maxHeight: window.innerWidth <= 768 ? '250px' : '300px', // Smaller on mobile
                          overflowY: 'auto',
                          overflowX: 'hidden',
                          zIndex: 10000, // Higher z-index for mobile
                          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                          WebkitOverflowScrolling: 'touch', // Smooth scrolling on iOS
                          touchAction: 'pan-y', // Enable vertical touch scrolling
                          scrollBehavior: 'smooth' // Smooth scrolling behavior
                        }}>
                          {filteredBusinessTypes.length > 0 ? (
                            filteredBusinessTypes.map(type => (
                              <div
                                key={type.value}
                                onClick={() => handleBusinessTypeSelect(type.value, type.label)}
                                style={{
                                  padding: '12px 16px',
                                  cursor: 'pointer',
                                  borderBottom: '1px solid #f3f4f6',
                                  transition: 'background-color 0.2s ease',
                                  ':hover': {
                                    backgroundColor: '#f9fafb'
                                  }
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.backgroundColor = '#f9fafb';
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.backgroundColor = 'white';
                                }}
                              >
                                {type.label}
                              </div>
                            ))
                          ) : (
                            <div style={{
                              padding: '12px 16px',
                              color: '#6b7280',
                              fontStyle: 'italic'
                            }}>
                              No business types found matching "{searchTerm}"
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    
                    {/* Hidden input for form validation */}
                    <input
                      type="hidden"
                      name="businessType"
                      value={formData.businessType}
                      required={formData.useType === 'business'}
                    />
                  </div>
                )}

               

              {/* Business/Personal Description Field - Commented out for modal choice */}
              {/* 
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                  <span>Business/Personal Description <span style={{ color: '#ef4444' }}>*</span></span>
                  <i 
                    className="fa fa-circle-info" 
                    style={{ 
                      fontSize: '16px', 
                      color: '#6b7280',
                      cursor: 'pointer',
                      transition: 'color 0.3s ease'
                    }}
                    title="This helps the AI understand your business to provide better customer service"
                    onMouseEnter={(e) => {
                      e.target.style.color = '#4f46e5';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = '#6b7280';
                    }}
                  ></i>
                </label>
                <textarea
                  name="businessDescription"
                  value={formData.businessDescription}
                  onChange={handleInputChange}
                  required
                  placeholder="Describe what your business/personal use case is, your main services/products, and what makes you unique..."
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '2px solid #e5e7eb',
                    borderRadius: '10px',
                    fontSize: '16px',
                    minHeight: '100px',
                    resize: 'vertical'
                  }}
                />
              </div>
              */}

                             {/* Business Hours and Time Zone fields commented out */}
               {/* 
               <div style={{ display: 'flex', gap: '20px' }}>
                 <div style={{ flex: 1 }}>
                   <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                     Business Hours <span style={{ color: '#ef4444' }}>*</span>
                   </label>
                   <input
                     type="text"
                     name="businessHours"
                     value={formData.businessHours}
                     onChange={handleInputChange}
                     required
                     placeholder="e.g., Mon-Fri 9AM-6PM, Sat 10AM-4PM"
                     style={{
                       width: '100%',
                       padding: '12px 16px',
                       border: '2px solid #e5e7eb',
                       borderRadius: '10px',
                       fontSize: '16px'
                     }}
                   />
                   <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '5px' }}>
                     When is your business open? This helps with scheduling and expectations
                   </div>
                 </div>

                 <div style={{ flex: 1 }}>
                   <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                     Time Zone <span style={{ color: '#ef4444' }}>*</span>
                   </label>
                   <select
                     name="timeZone"
                     value={formData.timeZone}
                     onChange={handleInputChange}
                     required
                     style={{
                       width: '100%',
                       padding: '12px 16px',
                       border: '2px solid #e5e7eb',
                       borderRadius: '10px',
                       fontSize: '16px'
                     }}
                   >
                     <option value="">Select your timezone</option>
                     <option value="Australia/Sydney">Sydney - Australian Eastern Time (AEST/AEDT)</option>
                     <option value="Australia/Melbourne">Melbourne - Australian Eastern Time (AEST/AEDT)</option>
                     <option value="Australia/Brisbane">Brisbane - Australian Eastern Standard Time (AEST)</option>
                     <option value="Australia/Adelaide">Adelaide - Australian Central Time (ACST/ACDT)</option>
                     <option value="Australia/Darwin">Darwin - Australian Central Standard Time (ACST)</option>
                     <option value="Australia/Perth">Perth - Australian Western Time (AWST)</option>
                     <option value="Australia/Hobart">Hobart - Australian Eastern Time (AEST/AEDT)</option>
                     <option value="Australia/Canberra">Canberra - Australian Eastern Time (AEST/AEDT)</option>
                     <option value="Australia/Lord_Howe">Lord Howe Island - Lord Howe Standard Time (LHST)</option>
                     <option value="Australia/Eucla">Eucla - Australian Central Western Time (ACWST)</option>
                   </select>
                 </div>
               </div>
               */}
            </div>

                        {/* Agent Personality & Voice Section */}
            {/* 
            <div style={{ marginBottom: '40px' }}>
              <h2 style={{
                fontSize: '1.5em',
                color: '#4f46e5',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e5e7eb',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <span style={{
                  width: '24px',
                  height: '24px',
                  background: '#4f46e5',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '14px'
                }}>2</span>
                Agent Personality & Voice
              </h2>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                  Agent Personality <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                  {['professional', 'friendly', 'energetic', 'calm'].map(personality => (
                    <div key={personality} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <input
                        type="radio"
                        name="agentPersonality"
                        value={personality}
                        checked={formData.agentPersonality === personality}
                        onChange={handleInputChange}
                        required
                        style={{ width: 'auto', margin: 0 }}
                      />
                      <label style={{ margin: 0, textTransform: 'capitalize' }}>
                        {personality === 'professional' ? 'Professional & Formal' :
                         personality === 'friendly' ? 'Friendly & Approachable' :
                         personality === 'energetic' ? 'Energetic & Enthusiastic' :
                         'Calm & Reassuring'}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
                <div style={{ flex: 1 }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                    Voice Gender
                  </label>
                  <select
                    name="voiceGender"
                    value={formData.voiceGender}
                    onChange={handleInputChange}
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '2px solid #e5e7eb',
                      borderRadius: '10px',
                      fontSize: '16px'
                    }}
                  >
                    <option value="neutral">No Preference</option>
                    <option value="female">Female</option>
                    <option value="male">Male</option>
                  </select>
                </div>

                <div style={{ flex: 1 }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                    Primary Language <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <select
                    name="language"
                    value={formData.language}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '2px solid #e5e7eb',
                      borderRadius: '10px',
                      fontSize: '16px'
                    }}
                  >
                    <option value="en-US">English (US)</option>
                    <option value="en-GB">English (UK)</option>
                    <option value="en-AU">English (Australia)</option>
                    <option value="es-ES">Spanish (Spain)</option>
                    <option value="es-419">Spanish (Latin America)</option>
                    <option value="fr-FR">French (France)</option>
                    <option value="fr-CA">French (Canada)</option>
                    <option value="de-DE">German</option>
                    <option value="it-IT">Italian</option>
                    <option value="pt-BR">Portuguese (Brazil)</option>
                    <option value="ja-JP">Japanese</option>
                    <option value="ko-KR">Korean</option>
                    <option value="zh-CN">Chinese (Simplified)</option>
                    <option value="hi-IN">Hindi</option>
                    <option value="ru-RU">Russian</option>
                  </select>
                </div>
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                  Custom Greeting Message <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <textarea
                  name="greetingMessage"
                  value={formData.greetingMessage}
                  onChange={handleInputChange}
                  required
                  placeholder="e.g., Thank you for calling [Business Name]! This is [Agent Name], your AI assistant. How can I help you today?"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '2px solid #e5e7eb',
                    borderRadius: '10px',
                    fontSize: '16px',
                    minHeight: '100px',
                    resize: 'vertical'
                  }}
                />
                <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '5px' }}>
                  The first thing customers will hear when they call. Use [Business Name] and [Agent Name] as placeholders.
                </div>
              </div>
            </div>
            */}

            {/* Services & Operations Section */}
            {/* 
            <div style={{ marginBottom: '40px' }}>
              <h2 style={{
                fontSize: '1.5em',
                color: '#4f46e5',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e5e7eb',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <span style={{
                  width: '24px',
                  height: '24px',
                  background: '#4f46e5',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '14px'
                }}>3</span>
                Services & Operations
              </h2>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                  Main Services/Products <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <textarea
                  name="primaryServices"
                  value={formData.primaryServices}
                  onChange={handleInputChange}
                  required
                  placeholder="List your main services or products, including pricing if you want the agent to provide quotes..."
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '2px solid #e5e7eb',
                    borderRadius: '10px',
                    fontSize: '16px',
                    minHeight: '100px',
                    resize: 'vertical'
                  }}
                />
                <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '5px' }}>
                  What can the AI help customers with? Include pricing information if you want the agent to provide quotes.
                </div>
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                  Common Customer Questions
                </label>
                <textarea
                  name="commonQuestions"
                  value={formData.commonQuestions}
                  onChange={handleInputChange}
                  placeholder="e.g., Do you accept insurance? What forms of payment do you accept? Do you offer delivery?"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '2px solid #e5e7eb',
                    borderRadius: '10px',
                    fontSize: '16px',
                    minHeight: '100px',
                    resize: 'vertical'
                  }}
                />
                <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '5px' }}>
                  What questions do customers frequently ask? This helps the AI provide better answers.
                </div>
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                  Appointment Types (if applicable)
                </label>
                <textarea
                  name="appointmentTypes"
                  value={formData.appointmentTypes}
                  onChange={handleInputChange}
                  placeholder="e.g., Consultation (30 min), Full Service (60 min), Follow-up (15 min)"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '2px solid #e5e7eb',
                    borderRadius: '10px',
                    fontSize: '16px',
                    minHeight: '100px',
                    resize: 'vertical'
                  }}
                />
                <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '5px' }}>
                  If you take appointments, what types do you offer and how long do they take?
                </div>
              </div>
            </div>
            */}

            {/* Call Handling Section */}
            {/* 
            <div style={{ marginBottom: '40px' }}>
              <h2 style={{
                fontSize: '1.5em',
                color: '#4f46e5',
                marginBottom: '20px',
                paddingBottom: '10px',
                borderBottom: '2px solid #e5e7eb',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <span style={{
                  width: '24px',
                  height: '24px',
                  background: '#4f46e5',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '14px'
                }}>4</span>
                Call Handling Preferences
              </h2>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                  What should the AI agent be able to do? <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
                  {[
                    { value: 'answer_questions', label: 'Answer questions about services/products' },
                    { value: 'schedule_appointments', label: 'Schedule appointments' },
                    { value: 'take_orders', label: 'Take orders or reservations' },
                    { value: 'provide_directions', label: 'Provide business location/directions' },
                    { value: 'collect_info', label: 'Collect customer information' },
                    { value: 'transfer_calls', label: 'Transfer calls to human staff' }
                  ].map(capability => (
                    <div key={capability.value} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <input
                        type="checkbox"
                        name="capabilities"
                        value={capability.value}
                        checked={formData.capabilities.includes(capability.value)}
                        onChange={handleInputChange}
                        style={{ width: 'auto', margin: 0 }}
                      />
                      <label style={{ margin: 0 }}>{capability.label}</label>
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                  When should calls be transferred to humans?
                </label>
                <textarea
                  name="transferScenarios"
                  value={formData.transferScenarios}
                  onChange={handleInputChange}
                  placeholder="e.g., Complex technical issues, complaints, requests for manager, medical emergencies..."
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '2px solid #e5e7eb',
                    borderRadius: '10px',
                    fontSize: '16px',
                    minHeight: '100px',
                    resize: 'vertical'
                  }}
                />
                <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '5px' }}>
                  Describe situations where the AI should transfer calls to human staff
                </div>
              </div>

              <div style={{ display: 'flex', gap: '20px' }}>
                <div style={{ flex: 1 }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                    Transfer Phone Number
                  </label>
                  <input
                    type="tel"
                    name="transferNumber"
                    value={formData.transferNumber}
                    onChange={handleInputChange}
                    placeholder="e.g., +1-555-123-4567"
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '2px solid #e5e7eb',
                      borderRadius: '10px',
                      fontSize: '16px'
                    }}
                  />
                  <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '5px' }}>
                    Number to transfer calls to (if applicable)
                  </div>
                </div>

                <div style={{ flex: 1 }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                    After Hours Message
                  </label>
                  <textarea
                    name="afterHoursMessage"
                    value={formData.afterHoursMessage}
                    onChange={handleInputChange}
                    placeholder="e.g., Thank you for calling! We're currently closed. Our hours are..."
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '2px solid #e5e7eb',
                      borderRadius: '10px',
                      fontSize: '16px',
                      minHeight: '100px',
                      resize: 'vertical'
                    }}
                  />
                  <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '5px' }}>
                    What should the AI say when called outside business hours?
                  </div>
                </div>
              </div>
            </div>
            */}

            {/* Advanced Settings Section */}
            {/* 
            <div style={{ marginBottom: '40px' }}>
              <div
                onClick={toggleAdvanced}
                style={{
                  background: '#f3f4f6',
                  padding: '15px',
                  borderRadius: '10px',
                  marginBottom: '20px',
                  cursor: 'pointer',
                  userSelect: 'none',
                  transition: 'background-color 0.3s ease'
                }}
              >
                <h2 style={{
                  fontSize: '1.5em',
                  color: '#4f46e5',
                  margin: 0,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px'
                }}>
                  <span style={{
                    width: '24px',
                    height: '24px',
                    background: '#4f46e5',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '14px'
                  }}>5</span>
                  Advanced Settings (Optional)
                  <span style={{ marginLeft: 'auto', fontSize: '14px' }}>
                    {showAdvanced ? 'Click to collapse ▲' : 'Click to expand ▼'}
                  </span>
                </h2>
              </div>

              {showAdvanced && (
                <div>
                  <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                        Maximum Call Duration (minutes)
                      </label>
                      <input
                        type="number"
                        name="maxCallDuration"
                        value={formData.maxCallDuration}
                        onChange={handleInputChange}
                        min="1"
                        max="60"
                        style={{
                          width: '100%',
                          padding: '12px 16px',
                          border: '2px solid #e5e7eb',
                          borderRadius: '10px',
                          fontSize: '16px'
                        }}
                      />
                      <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '5px' }}>
                        How long should calls be allowed to last? (1-60 minutes)
                      </div>
                    </div>

                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                        End Call After Silence (seconds)
                      </label>
                      <input
                        type="number"
                        name="silenceTimeout"
                        value={formData.silenceTimeout}
                        onChange={handleInputChange}
                        min="10"
                        max="120"
                        style={{
                          width: '100%',
                          padding: '12px 16px',
                          border: '2px solid #e5e7eb',
                          borderRadius: '10px',
                          fontSize: '16px'
                        }}
                      />
                      <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '5px' }}>
                        End call after this many seconds of silence
                      </div>
                    </div>
                  </div>

                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                      Webhook URL
                    </label>
                    <input
                      type="url"
                      name="webhookUrl"
                      value={formData.webhookUrl}
                      onChange={handleInputChange}
                      placeholder="https://your-server.com/webhook"
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        border: '2px solid #e5e7eb',
                        borderRadius: '10px',
                        fontSize: '16px'
                      }}
                    />
                    <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '5px' }}>
                      For advanced integrations (leave blank if unsure)
                    </div>
                  </div>

                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                      Calendar Integration
                    </label>
                    <select
                      name="calendarIntegration"
                      value={formData.calendarIntegration}
                      onChange={handleInputChange}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        border: '2px solid #e5e7eb',
                        borderRadius: '10px',
                        fontSize: '16px'
                    }}
                    >
                      <option value="">No Calendar Integration</option>
                      <option value="cal.com">Cal.com</option>
                      <option value="calendly">Calendly</option>
                      <option value="custom">Custom Calendar API</option>
                    </select>
                    <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '5px' }}>
                      Connect to your calendar for appointment scheduling
                    </div>
                  </div>

                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#374151' }}>
                      Additional Instructions
                    </label>
                    <textarea
                      name="additionalInstructions"
                      value={formData.additionalInstructions}
                      onChange={handleInputChange}
                      placeholder="Any specific instructions for how the AI should behave or handle certain situations..."
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        border: '2px solid #e5e7eb',
                        borderRadius: '10px',
                        fontSize: '16px',
                        minHeight: '100px',
                        resize: 'vertical'
                      }}
                    />
                    <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '5px' }}>
                      Any special instructions or behaviors you want the AI to follow
                    </div>
                  </div>
                </div>
              )}
            </div>
            */}

            {/* Voice Configuration Note */}
            <div style={{ 
              background: '#f0f9ff', 
              border: '1px solid #0ea5e9', 
              borderRadius: '8px', 
              padding: '12px', 
              marginBottom: '20px',
              fontSize: '14px',
              color: '#0369a1'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                <i className="fas fa-microphone" style={{ fontSize: '16px' }}></i>
                <strong>Voice Configuration</strong>
              </div>
              <p style={{ margin: '0', lineHeight: '1.5' }}>
                Your agent will be created with a default voice and English language. You can change the voice later in your agent settings after creation.
              </p>
            </div>

            {/* Phone Number Purchasing Status */}
            {isPurchasingPhone && (
              <div style={{
                background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                border: '1px solid #3b82f6',
                color: '#1e40af',
                padding: '16px 20px',
                borderRadius: '12px',
                marginBottom: '20px',
                textAlign: 'center',
                boxShadow: '0 4px 12px rgba(59, 130, 246, 0.15)'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '8px' }}>
                  <div style={{
                    width: '20px',
                    height: '20px',
                    border: '2px solid #3b82f6',
                    borderTop: '2px solid transparent',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }}></div>
                  <span style={{ fontSize: '16px', fontWeight: '600' }}>Creating Your Agent</span>
                </div>
                <p style={{ margin: '0', fontSize: '14px', opacity: '0.9' }}>
                  {phonePurchaseStatus}
                </p>
                {purchasedPhoneNumber && (
                  <div style={{ marginTop: '12px', padding: '8px 12px', background: 'rgba(34, 197, 94, 0.1)', borderRadius: '8px', border: '1px solid rgba(34, 197, 94, 0.2)' }}>
                    <span style={{ fontSize: '14px', color: '#166534', fontWeight: '500' }}>
                      📞 Phone Number: {purchasedPhoneNumber.phone_number}
                    </span>
                    <br />
                    <span style={{ fontSize: '12px', color: '#166534', opacity: '0.8' }}>
                      {purchasedPhoneNumber.price ? `Price: $${purchasedPhoneNumber.price} (with 2x markup)` : 
                       purchasedPhoneNumber.existing_mode ? 'Existing Phone Number (No Charge)' : 'Test Phone Number (No Charge)'}
                    </span>
                  </div>
                )}
              </div>
            )}

            {/* Error Message */}
            {error && (
              <div style={{
                background: '#fef2f2',
                border: '1px solid #fecaca',
                color: '#dc2626',
                padding: '12px 16px',
                borderRadius: '10px',
                marginBottom: '20px'
              }}>
                {error}
              </div>
            )}


            {/* Submit Button */}
            <button
              type="submit"
              disabled={isSubmitting}
              style={{
                background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
                color: 'white',
                padding: '16px 40px',
                border: 'none',
                borderRadius: '10px',
                fontSize: '18px',
                fontWeight: '600',
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                transition: 'transform 0.2s ease',
                width: '100%',
                marginTop: '20px',
                opacity: isSubmitting ? 0.7 : 1
              }}
            >
              {isSubmitting ? 'Creating Agent...' : '🚀 Create My AI Agent'}
            </button>
          </form>
        </div>
      </div>

      {/* Description Choice Modal */}
      {showDescriptionModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10000,
          padding: '20px'
        }}>
          <div style={{
            background: 'white',
            borderRadius: '16px',
            padding: '40px',
            maxWidth: '900px',
            width: '100%',
            maxHeight: '90vh',
            overflowY: 'auto',
            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25)',
            textAlign: 'center',
            position: 'relative'
          }}>
            {/* Close Button */}
            <button
              onClick={() => setShowDescriptionModal(false)}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                background: 'transparent',
                border: 'none',
                fontSize: '24px',
                color: '#9ca3af',
                cursor: 'pointer',
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#f3f4f6';
                e.target.style.color = '#6b7280';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.color = '#9ca3af';
              }}
              title="Close"
            >
              ×
            </button>
            <h2 style={{
              fontSize: '1.8em',
              color: '#4f46e5',
              marginBottom: '15px',
              fontWeight: '700',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '12px'
            }}>
              🤔 Business/Personal Description
            </h2>
            
            {/* Context Information */}
            {modalContext && (
              <div style={{
                background: '#f8fafc',
                border: '1px solid #e2e8f0',
                borderRadius: '12px',
                padding: '20px',
                marginBottom: '20px',
                textAlign: 'left'
              }}>
                <h3 style={{
                  fontSize: '1.1em',
                  color: '#4f46e5',
                  marginBottom: '12px',
                  fontWeight: '600'
                }}>
                  📋 Current Setup:
                </h3>
                <div style={{ fontSize: '0.95em', color: '#64748b', lineHeight: '1.6' }}>
                  <div style={{ marginBottom: '8px' }}>
                    <strong>Agent Name:</strong> {modalContext.agentName}
                  </div>
                  <div style={{ marginBottom: '8px' }}>
                    <strong>Category:</strong> {modalContext.useType === 'business' ? 'Business' : 'Personal'}
                  </div>
                  {modalContext.useType === 'business' && modalContext.businessName && (
                    <div style={{ marginBottom: '8px' }}>
                      <strong>Business Name:</strong> {modalContext.businessName}
                    </div>
                  )}
                  {modalContext.useType === 'business' && modalContext.businessTypeLabel && (
                    <div style={{ marginBottom: '8px' }}>
                      <strong>Business Type:</strong> {modalContext.businessTypeLabel}
                    </div>
                  )}
                  {modalContext.useType === 'personal' && modalContext.personalReason && (
                    <div style={{ marginBottom: '8px' }}>
                      <strong>Personal Reason:</strong> {modalContext.personalReason}
                    </div>
                  )}
                </div>
              </div>
            )}
            
            <p style={{
              fontSize: '1.1em',
              color: '#6b7280',
              marginBottom: '20px',
              lineHeight: '1.6'
            }}>
              Would you like help setting up your assistant, or do you prefer to enter the details yourself?
            </p>
            
            <p style={{
              fontSize: '0.95em',
              color: '#9ca3af',
              marginBottom: '30px',
              lineHeight: '1.5',
              fontStyle: 'italic'
            }}>
              We can guide you through adding helpful information like business hours, services, or personal preferences — so your assistant gives callers the best possible experience.
            </p>
            
            {!showDescriptionField ? (
              <div style={{
                display: 'flex',
                gap: '20px',
                justifyContent: 'center'
              }}>
                <button
                  onClick={() => handleDescriptionChoice('describe-yourself')}
                  style={{
                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                    border: 'none',
                    borderRadius: '12px',
                    padding: '16px 24px',
                    color: 'white',
                    fontSize: '1rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 15px rgba(16, 185, 129, 0.3)',
                    minWidth: '200px',
                    justifyContent: 'center'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(16, 185, 129, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(16, 185, 129, 0.3)';
                  }}
                >
                  <span style={{ fontSize: '1.2rem' }}>✍️</span>
                  I'll Do It Myself
                </button>
                
                <button
                  onClick={() => handleDescriptionChoice('ai-assistant')}
                  style={{
                    background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
                    border: 'none',
                    borderRadius: '12px',
                    padding: '16px 24px',
                    color: 'white',
                    fontSize: '1rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 15px rgba(79, 70, 229, 0.3)',
                    minWidth: '200px',
                    justifyContent: 'center'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(79, 70, 229, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(79, 70, 229, 0.3)';
                  }}
                >
                  <span style={{ fontSize: '1.2rem' }}>✅</span>
                  Let AI Assist Me
                </button>
              </div>
            ) : (
              <div style={{
                background: '#f8fafc',
                border: '1px solid #e2e8f0',
                borderRadius: '12px',
                padding: '20px',
                marginTop: '20px'
              }}>
                <h3 style={{
                  fontSize: '1.1em',
                  color: '#4f46e5',
                  marginBottom: '12px',
                  fontWeight: '600'
                }}>
                  📝 Enter Your Description:
                </h3>
                
                {/* Show loading state */}
                {loadingPrompt && (
                  <div style={{
                    textAlign: 'center',
                    padding: '20px',
                    color: '#6b7280'
                  }}>
                    <div style={{ fontSize: '1.2rem', marginBottom: '10px' }}>⏳</div>
                    Loading prompt data...
                  </div>
                )}
                
                <textarea
                  name="businessDescription"
                  value={(() => {
                    // If we have prompt data, use the cleaned version as default
                    if (promptData && !formData.businessDescription) {
                      const fullPrompt = modalContext?.useType === 'business' 
                        ? promptData.generalPrompt 
                        : promptData.personalPrompt;
                      
                      // Process the prompt for display
                      let displayPrompt = fullPrompt;
                      
                      // Keep the caller number verification section but clean it up
                      // Replace phone number arrays with placeholder
                      displayPrompt = displayPrompt.replace(/\[[+\d\s,]+]/g, '{{verified_numbers}}');
                      displayPrompt = displayPrompt.replace(/\["[+\d\s,]+"]/g, '{{verified_numbers}}');
                      
                      // Clean up any double spaces but preserve line breaks
                      displayPrompt = displayPrompt.replace(/[ \t]+/g, ' ');
                      displayPrompt = displayPrompt.replace(/\n\s*\n/g, '\n\n');
                      
                      return displayPrompt.trim();
                    }
                    return formData.businessDescription;
                  })()}
                  onChange={handleInputChange}
                  placeholder="Describe what your business/personal use case is, your main services/products, and what makes you unique..."
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '2px solid #e5e7eb',
                    borderRadius: '10px',
                    fontSize: '16px',
                    minHeight: '200px',
                    resize: 'vertical',
                    fontFamily: 'inherit'
                  }}
                />
                <div style={{
                  display: 'flex',
                  gap: '12px',
                  justifyContent: 'flex-end',
                  marginTop: '16px'
                }}>
                  <button
                    onClick={() => {
                      setShowDescriptionField(false);
                      setPromptData(null);
                    }}
                    style={{
                      background: 'transparent',
                      border: '1px solid #e5e7eb',
                      borderRadius: '8px',
                      padding: '10px 20px',
                      color: '#6b7280',
                      fontSize: '0.9rem',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = '#f9fafb';
                      e.target.style.borderColor = '#d1d5db';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = 'transparent';
                      e.target.style.borderColor = '#e5e7eb';
                    }}
                  >
                    Back
                  </button>
                  <button
                    onClick={() => {
                      if (formData.businessDescription && formData.businessDescription.trim() !== '') {
                        setShowPhoneNumberSelection(true);
                        fetchAvailablePhoneNumbers();
                      }
                    }}
                    disabled={!formData.businessDescription || formData.businessDescription.trim() === ''}
                    style={{
                      background: formData.businessDescription && formData.businessDescription.trim() !== '' 
                        ? 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)' 
                        : '#e5e7eb',
                      border: 'none',
                      borderRadius: '8px',
                      padding: '10px 20px',
                      color: formData.businessDescription && formData.businessDescription.trim() !== '' 
                        ? 'white' 
                        : '#9ca3af',
                      fontSize: '0.9rem',
                      cursor: formData.businessDescription && formData.businessDescription.trim() !== '' 
                        ? 'pointer' 
                        : 'not-allowed',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
            
            {/* Phone Number Selection Section */}
            {showPhoneNumberSelection && (
              <div style={{
                background: '#f8fafc',
                border: '1px solid #e2e8f0',
                borderRadius: '12px',
                padding: '20px',
                marginTop: '20px'
              }}>
                <h3 style={{
                  fontSize: '1.1em',
                  color: '#4f46e5',
                  marginBottom: '16px',
                  fontWeight: '600'
                }}>
                  📞 Phone Number Selection:
                </h3>
                
                <div style={{
                  display: 'flex',
                  gap: '16px',
                  marginBottom: '20px',
                  flexWrap: 'wrap'
                }}>
                  <button
                    onClick={() => handlePhoneNumberOption('existing')}
                    style={{
                      flex: 1,
                      minWidth: '200px',
                      padding: '14px 20px',
                      background: phoneNumberOption === 'existing' 
                        ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)' 
                        : '#ffffff',
                      border: phoneNumberOption === 'existing' 
                        ? '2px solid #10b981' 
                        : '2px solid #e5e7eb',
                      borderRadius: '10px',
                      color: phoneNumberOption === 'existing' ? 'white' : '#374151',
                      fontSize: '0.95rem',
                      fontWeight: '600',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      boxShadow: phoneNumberOption === 'existing' 
                        ? '0 4px 15px rgba(16, 185, 129, 0.3)' 
                        : '0 2px 8px rgba(0, 0, 0, 0.05)'
                    }}
                    onMouseEnter={(e) => {
                      if (phoneNumberOption !== 'existing') {
                        e.target.style.borderColor = '#10b981';
                        e.target.style.boxShadow = '0 4px 15px rgba(16, 185, 129, 0.2)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (phoneNumberOption !== 'existing') {
                        e.target.style.borderColor = '#e5e7eb';
                        e.target.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.05)';
                      }
                    }}
                  >
                    <span style={{ fontSize: '1.2rem', marginRight: '8px' }}>📋</span>
                    Select Existing Phone Number
                  </button>
                  
                  <button
                    onClick={() => handlePhoneNumberOption('buy-new')}
                    style={{
                      flex: 1,
                      minWidth: '200px',
                      padding: '14px 20px',
                      background: phoneNumberOption === 'buy-new' 
                        ? 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)' 
                        : '#ffffff',
                      border: phoneNumberOption === 'buy-new' 
                        ? '2px solid #4f46e5' 
                        : '2px solid #e5e7eb',
                      borderRadius: '10px',
                      color: phoneNumberOption === 'buy-new' ? 'white' : '#374151',
                      fontSize: '0.95rem',
                      fontWeight: '600',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      boxShadow: phoneNumberOption === 'buy-new' 
                        ? '0 4px 15px rgba(79, 70, 229, 0.3)' 
                        : '0 2px 8px rgba(0, 0, 0, 0.05)'
                    }}
                    onMouseEnter={(e) => {
                      if (phoneNumberOption !== 'buy-new') {
                        e.target.style.borderColor = '#4f46e5';
                        e.target.style.boxShadow = '0 4px 15px rgba(79, 70, 229, 0.2)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (phoneNumberOption !== 'buy-new') {
                        e.target.style.borderColor = '#e5e7eb';
                        e.target.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.05)';
                      }
                    }}
                  >
                    <span style={{ fontSize: '1.2rem', marginRight: '8px' }}>🛒</span>
                    Buy New Phone Number
                  </button>
                </div>
                
                {/* Existing Phone Number Dropdown */}
                {phoneNumberOption === 'existing' && (
                  <div style={{ marginBottom: '20px' }}>
                    <label style={{
                      display: 'block',
                      fontSize: '0.9rem',
                      fontWeight: '600',
                      color: '#374151',
                      marginBottom: '8px'
                    }}>
                      Select Phone Number:
                    </label>
                    {loadingPhoneNumbers ? (
                      <div style={{
                        padding: '12px',
                        textAlign: 'center',
                        color: '#6b7280'
                      }}>
                        <span style={{ marginRight: '8px' }}>⏳</span>
                        Loading phone numbers...
                      </div>
                    ) : availablePhoneNumbers.length > 0 ? (
                      <select
                        value={selectedExistingPhoneNumber}
                        onChange={(e) => setSelectedExistingPhoneNumber(e.target.value)}
                        style={{
                          width: '100%',
                          padding: '12px 16px',
                          border: '2px solid #e5e7eb',
                          borderRadius: '10px',
                          fontSize: '16px',
                          backgroundColor: '#ffffff',
                          color: '#374151',
                          cursor: 'pointer',
                          transition: 'border-color 0.3s ease'
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#4f46e5'}
                        onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                      >
                        <option value="">-- Select a phone number --</option>
                        {availablePhoneNumbers.map((phone, index) => (
                          <option key={index} value={phone.phone_numbers || phone.phone_number_pretty || phone.phone_number}>
                            {phone.phone_number_pretty || phone.phone_numbers || phone.phone_number} 
                            {phone.nickname ? ` (${phone.nickname})` : ''}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <div style={{
                        padding: '12px',
                        background: '#fef3c7',
                        border: '1px solid #fbbf24',
                        borderRadius: '8px',
                        color: '#92400e'
                      }}>
                        <span style={{ marginRight: '8px' }}>⚠️</span>
                        No existing phone numbers found. Please select "Buy New Phone Number" instead.
                      </div>
                    )}
                  </div>
                )}
                
                {/* Action Buttons */}
                <div style={{
                  display: 'flex',
                  gap: '12px',
                  justifyContent: 'flex-end'
                }}>
                  <button
                    onClick={() => {
                      setShowPhoneNumberSelection(false);
                      setPhoneNumberOption('');
                      setSelectedExistingPhoneNumber('');
                    }}
                    style={{
                      background: 'transparent',
                      border: '1px solid #e5e7eb',
                      borderRadius: '8px',
                      padding: '10px 20px',
                      color: '#6b7280',
                      fontSize: '0.9rem',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = '#f9fafb';
                      e.target.style.borderColor = '#d1d5db';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = 'transparent';
                      e.target.style.borderColor = '#e5e7eb';
                    }}
                  >
                    Back
                  </button>
                  <button
                    onClick={handleDescriptionSubmit}
                    disabled={!phoneNumberOption || (phoneNumberOption === 'existing' && !selectedExistingPhoneNumber)}
                    style={{
                      background: phoneNumberOption && (phoneNumberOption === 'buy-new' || selectedExistingPhoneNumber)
                        ? 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)' 
                        : '#e5e7eb',
                      border: 'none',
                      borderRadius: '8px',
                      padding: '10px 20px',
                      color: phoneNumberOption && (phoneNumberOption === 'buy-new' || selectedExistingPhoneNumber)
                        ? 'white' 
                        : '#9ca3af',
                      fontSize: '0.9rem',
                      cursor: phoneNumberOption && (phoneNumberOption === 'buy-new' || selectedExistingPhoneNumber)
                        ? 'pointer' 
                        : 'not-allowed',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    Create Agent
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* AI Assistant Popup */}
      {showAIAssistantPopup && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10000,
          padding: '10px'
        }}>
          <div style={{
            width: '95%',
            maxWidth: '1400px',
            height: '95%',
            maxHeight: '900px',
            backgroundColor: '#fff',
            borderRadius: '20px',
            boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            position: 'relative'
          }}>
            {/* Popup Header */}
            <div style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              padding: '12px 20px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderTopLeftRadius: '20px',
              borderTopRightRadius: '20px',
              minHeight: '50px'
            }}>
              <h2 style={{
                margin: 0,
                fontSize: '1.1rem',
                fontWeight: '600'
              }}>
                🤖 AI Assistant - Description Help
              </h2>
              <button
                onClick={handleAIAssistantPopupClose}
                style={{
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: 'none',
                  borderRadius: '50%',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  color: '#fff',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.3)';
                  e.target.style.transform = 'scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                  e.target.style.transform = 'scale(1)';
                }}
                title="Close AI Assistant"
              >
                ×
              </button>
            </div>

            {/* AI Assistant Content */}
            <div style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              minHeight: 0
            }}>
              <AIAssistant 
                onClose={handleAIAssistantPopupClose}
                isAgentDetails={false}
                currentUser={{
                  id: userId,
                  email: userEmail,
                  full_name: 'User'
                }}
                formContext={aiAssistantContext}
                onDescriptionGenerated={handleDescriptionGenerated}
              />
            </div>
          </div>
        </div>
      )}

      {/* Phone Purchase Popup - Exciting Message While Phone Number is Being Bought */}
      {showPhonePurchasePopup && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10001,
          padding: '20px',
          backdropFilter: 'blur(5px)'
        }}>
          <div style={{
            width: '100%',
            maxWidth: '500px',
            backgroundColor: '#fff',
            borderRadius: '24px',
            boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
            padding: '40px 30px',
            textAlign: 'center',
            position: 'relative',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: '#fff',
            animation: 'fadeInScale 0.3s ease-out'
          }}>
            {/* Animated Phone Icon */}
            <div style={{
              fontSize: '64px',
              marginBottom: '20px',
              animation: 'bounce 2s infinite',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              📞
            </div>

            {/* Main Heading */}
            <h2 style={{
              margin: '0 0 16px 0',
              fontSize: '28px',
              fontWeight: '700',
              color: '#fff',
              textShadow: '0 2px 4px rgba(0,0,0,0.2)'
            }}>
              🎉 Exciting Things Are Happening!
            </h2>

            {/* Subheading */}
            <p style={{
              margin: '0 0 24px 0',
              fontSize: '18px',
              fontWeight: '500',
              color: 'rgba(255, 255, 255, 0.95)',
              lineHeight: '1.5'
            }}>
              We're securing your exclusive phone number right now!
            </p>

            {/* Description */}
            <div style={{
              background: 'rgba(255, 255, 255, 0.15)',
              borderRadius: '16px',
              padding: '20px',
              marginBottom: '24px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.2)'
            }}>
              <p style={{
                margin: '0 0 12px 0',
                fontSize: '16px',
                color: 'rgba(255, 255, 255, 0.9)',
                lineHeight: '1.6'
              }}>
                ✨ Your AI agent is being created with cutting-edge technology
              </p>
              <p style={{
                margin: '0 0 12px 0',
                fontSize: '16px',
                color: 'rgba(255, 255, 255, 0.9)',
                lineHeight: '1.6'
              }}>
                📱 We're purchasing a premium phone number just for you
              </p>
              <p style={{
                margin: '0',
                fontSize: '16px',
                color: 'rgba(255, 255, 255, 0.9)',
                lineHeight: '1.6',
                fontWeight: '600'
              }}>
                ⏳ Please hold on - this will only take a moment!
              </p>
            </div>

            {/* Loading Spinner */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '12px',
              marginTop: '20px'
            }}>
              <div style={{
                width: '40px',
                height: '40px',
                border: '4px solid rgba(255, 255, 255, 0.3)',
                borderTop: '4px solid #fff',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }}></div>
              <span style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#fff'
              }}>
                Processing...
              </span>
            </div>

            {/* Fun Message */}
            <p style={{
              margin: '24px 0 0 0',
              fontSize: '14px',
              color: 'rgba(255, 255, 255, 0.8)',
              fontStyle: 'italic'
            }}>
              🚀 Your AI-powered communication revolution starts here!
            </p>
          </div>
        </div>
      )}

      {/* Verified Numbers Popup - Commented out */}
      {false && showVerifiedNumbersPopup && (
        <VerifiedNumbers 
          isModal={true} 
          onClose={() => {
            console.log('🔍 [CREATE AGENT FORM] Closing VerifiedNumbers popup');
            setShowVerifiedNumbersPopup(false);
            // Show progress popup after verified numbers popup closes (only if not already showing)
            if (!showProgressPopup) {
              setShowProgressPopup(true);
              setProgressValue(0);
              setCountdownSeconds(10);
              setProgressMessage('Preparing your agent...');
            }
          }} 
        />
      )}


        {/* Call Transfer Popup */}
        {showCallTransferPopup && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10001
          }}>
            <div style={{
              background: '#1f2937',
              borderRadius: '12px',
              padding: '24px',
              width: '600px',
              maxWidth: '90vw',
              maxHeight: '80vh',
              overflowY: 'auto',
              boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
            }}>
              {/* Header */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '20px'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <i className="fas fa-phone" style={{ 
                    color: '#6b7280', 
                    fontSize: '18px' 
                  }}></i>
                  <span style={{
                    color: '#f9fafb',
                    fontSize: '18px',
                    fontWeight: '600'
                  }}>
                    Call Transfer Setup
                  </span>
                </div>
                <button
                  onClick={() => setShowCallTransferPopup(false)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#6b7280',
                    fontSize: '18px',
                    cursor: 'pointer',
                    padding: '4px',
                    borderRadius: '4px',
                    transition: 'color 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#f9fafb'}
                  onMouseLeave={(e) => e.target.style.color = '#6b7280'}
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>

              {/* Content */}
              <div style={{ marginBottom: '20px' }}>
                {/* Name Field */}
                <div style={{ marginBottom: '16px' }}>
                  <label style={{
                    display: 'block',
                    color: '#f9fafb',
                    fontSize: '14px',
                    fontWeight: '500',
                    marginBottom: '6px'
                  }}>
                    Name
                  </label>
                  <input
                    type="text"
                    value="transfer_call"
                    readOnly
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      background: '#374151',
                      border: '1px solid #4b5563',
                      borderRadius: '6px',
                      color: '#f9fafb',
                      fontSize: '14px',
                      outline: 'none'
                    }}
                  />
                </div>

                {/* Description Field */}
                <div style={{ marginBottom: '16px' }}>
                  <label style={{
                    display: 'block',
                    color: '#f9fafb',
                    fontSize: '14px',
                    fontWeight: '500',
                    marginBottom: '6px'
                  }}>
                    Description (Optional)
                  </label>
                  <input
                    type="text"
                    value="Transfer the call to a human agent."
                    readOnly
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      background: '#374151',
                      border: '1px solid #4b5563',
                      borderRadius: '6px',
                      color: '#f9fafb',
                      fontSize: '14px',
                      outline: 'none'
                    }}
                  />
                </div>

                {/* Transfer to Section */}
                <div style={{ marginBottom: '24px' }}>
                  <h3 style={{
                    color: '#f9fafb',
                    fontSize: '16px',
                    fontWeight: '600',
                    marginBottom: '12px'
                  }}>
                    Transfer to
                  </h3>
                  <div style={{
                    display: 'flex',
                    gap: '8px',
                    marginBottom: '12px'
                  }}>
                    <button
                      type="button"
                      style={{
                        padding: '8px 16px',
                        background: '#3b82f6',
                        border: '1px solid #4b5563',
                        borderRadius: '6px',
                        color: '#f9fafb',
                        fontSize: '14px',
                        fontWeight: '500',
                        cursor: 'pointer',
                        transition: 'background-color 0.2s ease'
                      }}
                    >
                      Static Destination
                    </button>
                    <button
                      type="button"
                      style={{
                        padding: '8px 16px',
                        background: '#374151',
                        border: '1px solid #4b5563',
                        borderRadius: '6px',
                        color: '#f9fafb',
                        fontSize: '14px',
                        fontWeight: '500',
                        cursor: 'pointer',
                        transition: 'background-color 0.2s ease'
                      }}
                    >
                      Dynamic Routing
                    </button>
                  </div>
                  <input
                    type="text"
                    value={transferPhoneNumber}
                    onChange={(e) => setTransferPhoneNumber(e.target.value)}
                    placeholder="+18563630633"
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      background: '#374151',
                      border: '1px solid #4b5563',
                      borderRadius: '6px',
                      color: '#f9fafb',
                      fontSize: '14px',
                      outline: 'none',
                      transition: 'border-color 0.2s ease'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                    onBlur={(e) => e.target.style.borderColor = '#4b5563'}
                  />
                  <p style={{
                    color: '#9ca3af',
                    fontSize: '12px',
                    marginTop: '4px',
                    marginBottom: '0'
                  }}>
                    Enter a static phone number / SIP URI / dynamic variable.
                  </p>
                </div>

                {/* Type Section */}
                <div style={{ marginBottom: '24px' }}>
                  <h3 style={{
                    color: '#f9fafb',
                    fontSize: '16px',
                    fontWeight: '600',
                    marginBottom: '12px'
                  }}>
                    Type
                  </h3>
                  <div style={{ marginBottom: '8px' }}>
                    <label style={{
                      display: 'flex',
                      alignItems: 'center',
                      color: '#f9fafb',
                      fontSize: '14px',
                      fontWeight: '500',
                      cursor: 'pointer'
                    }}>
                      <input
                        type="radio"
                        name="transfer_type"
                        value="cold"
                        checked={transferType === 'cold'}
                        onChange={(e) => setTransferType(e.target.value)}
                        style={{
                          marginRight: '8px',
                          width: '16px',
                          height: '16px'
                        }}
                      />
                      Cold Transfer
                      <i className="fas fa-info-circle" style={{
                        marginLeft: '8px',
                        color: '#6b7280',
                        fontSize: '14px'
                      }}></i>
                    </label>
                  </div>
                  <div>
                    <label style={{
                      display: 'flex',
                      alignItems: 'center',
                      color: '#f9fafb',
                      fontSize: '14px',
                      fontWeight: '500',
                      cursor: 'pointer'
                    }}>
                      <input
                        type="radio"
                        name="transfer_type"
                        value="warm"
                        checked={transferType === 'warm'}
                        onChange={(e) => setTransferType(e.target.value)}
                        style={{
                          marginRight: '8px',
                          width: '16px',
                          height: '16px'
                        }}
                      />
                      Warm Transfer
                      <i className="fas fa-info-circle" style={{
                        marginLeft: '8px',
                        color: '#6b7280',
                        fontSize: '14px'
                      }}></i>
                    </label>
                  </div>
                </div>
              </div>

              {/* Actions */}
              <div style={{
                display: 'flex',
                gap: '12px',
                justifyContent: 'flex-end'
              }}>
                <button
                  onClick={() => setShowCallTransferPopup(false)}
                  style={{
                    background: '#374151',
                    color: '#f9fafb',
                    border: '1px solid #4b5563',
                    borderRadius: '6px',
                    padding: '10px 16px',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#4b5563'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#374151'}
                >
                  Cancel
                </button>
                <button
                  onClick={async () => {
                    if (transferPhoneNumber.trim()) {
                      try {
                        // Get user information
                        const user = JSON.parse(localStorage.getItem('chatbotUser'));
                        if (!user || !user.userId) {
                          throw new Error('User not found');
                        }

                        // Get the agent ID from the created agent (we need to store this from the agent creation response)
                        const createdAgentData = JSON.parse(localStorage.getItem('lastCreatedAgent'));
                        if (!createdAgentData || !createdAgentData.agent_id) {
                          throw new Error('Agent ID not found');
                        }

                        console.log('📞 Setting up call transfer for agent:', createdAgentData.agent_id);
                        console.log('📞 Transfer phone number:', transferPhoneNumber);

                        // Call the API to setup call transfer
                        const response = await fetch(`${API_BASE_URL}/api/agents/${createdAgentData.agent_id}/setup-call-transfer`, {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/json',
                          },
                          body: JSON.stringify({
                            user_id: user.userId,
                            transfer_phone_number: transferPhoneNumber,
                            transfer_type: transferType
                          })
                        });

                        if (!response.ok) {
                          const errorData = await response.json();
                          throw new Error(errorData.error || 'Failed to setup call transfer');
                        }

                        const result = await response.json();
                        console.log('✅ Call transfer setup completed:', result);
                        
                        alert(`Call transfer configured successfully! Transfer number: ${transferPhoneNumber}`);
                        setShowCallTransferPopup(false);
                        
                        // Show progress popup after call transfer setup (only if not already showing)
                        if (!showProgressPopup) {
                          setShowProgressPopup(true);
                          setProgressValue(0);
                          setCountdownSeconds(10);
                          setProgressMessage('Preparing your agent...');
                        }
                        
                        // Clear the stored agent data
                        localStorage.removeItem('lastCreatedAgent');

                      } catch (error) {
                        console.error('❌ Error setting up call transfer:', error);
                        alert(`Failed to setup call transfer: ${error.message}`);
                      }
                    } else {
                      alert('Please enter a valid phone number');
                    }
                  }}
                  style={{
                    background: '#10b981',
                    color: '#ffffff',
                    border: '1px solid #059669',
                    borderRadius: '6px',
                    padding: '10px 16px',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#059669'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#10b981'}
                >
                  <i className="fas fa-plus" style={{ marginRight: '8px' }}></i>
                  Add Transfer Tool to Agent
                </button>
              </div>
            </div>
          </div>
        )}

      {/* Progress Bar Popup */}
      {showProgressPopup && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10002,
          padding: '20px'
        }}>
          <div style={{
            background: 'white',
            borderRadius: '20px',
            padding: '40px',
            maxWidth: '500px',
            width: '100%',
            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25)',
            textAlign: 'center'
          }}>
            {/* Header */}
            <div style={{
              marginBottom: '30px'
            }}>
              <div style={{
                width: '80px',
                height: '80px',
                margin: '0 auto 20px',
                background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '40px',
                animation: 'pulse 2s ease-in-out infinite'
              }}>
                🤖
              </div>
              <h2 style={{
                fontSize: '1.8em',
                color: '#4f46e5',
                marginBottom: '10px',
                fontWeight: '700'
              }}>
                Your Agent is Being Prepared
              </h2>
              <p style={{
                fontSize: '1.1em',
                color: '#6b7280',
                margin: 0
              }}>
                {progressMessage}
              </p>
            </div>

            {/* Progress Bar Container */}
            <div style={{
              marginBottom: '30px'
            }}>
              <div style={{
                width: '100%',
                height: '12px',
                background: '#e5e7eb',
                borderRadius: '10px',
                overflow: 'hidden',
                marginBottom: '15px',
                position: 'relative'
              }}>
                <div style={{
                  width: `${progressValue}%`,
                  height: '100%',
                  background: 'linear-gradient(90deg, #4f46e5 0%, #7c3aed 100%)',
                  borderRadius: '10px',
                  transition: 'width 0.3s ease',
                  position: 'relative',
                  overflow: 'hidden'
                }}>
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
                    animation: 'shimmer 2s infinite'
                  }}></div>
                </div>
              </div>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                fontSize: '14px',
                color: '#6b7280'
              }}>
                <span>{Math.round(progressValue)}% Complete</span>
                <span>Estimated time: {countdownSeconds}s</span>
              </div>
            </div>

            {/* Status Messages */}
            <div style={{
              background: '#f8fafc',
              borderRadius: '12px',
              padding: '20px',
              marginBottom: '20px',
              textAlign: 'left'
            }}>
              <div style={{
                fontSize: '14px',
                color: '#64748b',
                lineHeight: '1.8'
              }}>
                {progressValue < 30 && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                    <span style={{ color: progressValue >= 10 ? '#10b981' : '#9ca3af' }}>✓</span>
                    <span>Agent created successfully</span>
                  </div>
                )}
                {progressValue >= 30 && progressValue < 60 && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                    <span style={{ color: '#10b981' }}>✓</span>
                    <span>Phone number configured</span>
                  </div>
                )}
                {progressValue >= 60 && progressValue < 90 && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                    <span style={{ color: '#10b981' }}>✓</span>
                    <span>Verified numbers processed</span>
                  </div>
                )}
                {progressValue >= 90 && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                    <span style={{ color: '#10b981' }}>✓</span>
                    <span>Finalizing setup...</span>
                  </div>
                )}
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ color: progressValue >= 100 ? '#10b981' : '#9ca3af' }}>
                    {progressValue >= 100 ? '✓' : '○'}
                  </span>
                  <span>Agent will appear on Agents page shortly</span>
                </div>
              </div>
            </div>

            {/* Info Message */}
            <p style={{
              fontSize: '13px',
              color: '#9ca3af',
              margin: 0,
              lineHeight: '1.6'
            }}>
              Your agent is being processed and will be available on the Agents page in a few moments. You can close this window and check back shortly.
            </p>
          </div>
        </div>
      )}
      </div>
    </>
  );
};

export default CreateAgentForm; 